// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DBS Travel Companion - Global CSS Variables */
:root {
  /* DBS Brand Colors - Official DBS Red */
  --dbs-red: #E31837;
  --dbs-red-dark: #c41530;
  --dbs-red-light: #f04058;

  /* Text Colors */
  --text-primary: #1a1a1a;
  --text-secondary: #666666;
  --text-muted: #999999;

  /* Background Colors */
  --bg-white: #ffffff;
  --bg-light: #f5f7f9;
  --bg-chat: #fafafa;

  /* Border & Shadow */
  --border-color: #e0e0e0;
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 25px rgba(0, 0, 0, 0.15);

  /* Border Radius */
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 20px;
  --radius-full: 50px;

  /* Spacing */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
}

/* Import Outfit font from Google Fonts */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: var(--bg-white);
  background-attachment: fixed;
  height: 100vh;
  overflow: hidden;
  color: var(--text-primary);
  line-height: 1.6;
  font-size: 14px;
}

/* ==================== Chat Mode Layout (with AppShell) ==================== */

/* Chat layout container inside AppShell */
.chat-layout {
  display: flex;
  width: 100%;
  height: calc(100vh - 120px);
  /* Subtract two-row navbar height */
  overflow: hidden;
}

.chat-area {
  flex: 1 1;
  display: flex;
  justify-content: center;
  transition: all 0.3s ease;
  overflow: hidden;
}

.chat-area.with-graph {
  flex: 0 0 50%;
  min-width: 400px;
  max-width: 50%;
}

.graph-area {
  flex: 0 0 50%;
  min-width: 500px;
  background: #1a1a1a;
  border-left: 2px solid #404040;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.graph-area.fullscreen {
  flex: 1 1;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  border-left: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.App.chat-hidden .chat-layout {
  justify-content: center;
}

/* Chat Content (message list + input) - no header */
.chat-content {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-white);
  border-left: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
}

.chat-area.with-graph .chat-content {
  max-width: 100%;
  border-right: none;
}

/* Landing content area */
.landing-content {
  width: 100%;
  padding-bottom: 3rem;
}

/* Legacy: Old main-layout for backward compatibility */
.main-layout {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.chat-section {
  flex: 1 1;
  display: flex;
  justify-content: center;
  transition: all 0.3s ease;
  overflow: hidden;
}

.chat-section.with-graph {
  flex: 0 0 50%;
  min-width: 400px;
  max-width: 50%;
}

.graph-section {
  flex: 0 0 50%;
  min-width: 500px;
  height: 100vh;
  background: #1a1a1a;
  border-left: 2px solid #404040;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.graph-section.fullscreen-centered {
  flex: 1 1;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  border-left: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.App.chat-hidden .main-layout {
  justify-content: center;
}

/* Legacy: Old Chat Container (kept for compatibility) */
.chat-container {
  max-width: 900px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: var(--bg-white);
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color);
  box-shadow: none;
}

.chat-section.with-graph .chat-container {
  max-width: 100%;
  box-shadow: none;
}

/* Legacy: Old Chat Header (no longer used, kept for backward compatibility) */
.chat-header {
  background: var(--dbs-red);
  color: white;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: var(--shadow-md);
  position: relative;
}

.chat-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.chat-header h1 {
  font-size: 20px;
  font-weight: 600;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.settings-btn,
.reset-btn,
.graph-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.settings-btn:hover,
.reset-btn:hover,
.graph-btn.active {
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.graph-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Chat Messages */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: var(--bg-white);
  /* Match landing page background */
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message {
  display: flex;
  gap: 12px;
}

/* User messages: slide in from right */
.message.user {
  animation: slideInFromRight 0.3s ease-in;
}

/* Assistant messages: keep original fadeIn animation */
.message.assistant {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Message layout - no avatar, just colored bubbles */
.message {
  display: flex;
  width: 100%;
  margin-bottom: 8px;
}

.message.user {
  justify-content: flex-end;
}

.message.assistant {
  justify-content: flex-start;
}

.message-content {
  padding: 12px 16px;
  border-radius: 18px;
  line-height: 1.6;
  word-wrap: break-word;
  font-size: 14px;
}

/* User messages: right-aligned, max 75% width */
.message.user .message-content {
  max-width: 75%;
}

/* AI messages: left-aligned, full width (100%) */
.message.assistant .message-content {
  width: 100%;
  max-width: 100%;
}

/* Ensure carousels and other components inside AI messages take full width of message-content */
.message.assistant .message-content .a2ui-carousel,
.message.assistant .message-content .destination-carousel,
.message.assistant .message-content .a2ui-carousel-container,
.message.assistant .message-content .destination-carousel-container {
  width: 100%;
  max-width: 100%;
}

.message.user .message-content {
  background: var(--dbs-red);
  /* DBS Red 品牌色 */
  color: white;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  border-bottom-left-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: var(--shadow-sm);
}

.message.assistant .message-content {
  background: transparent;
  color: var(--text-primary);
  border-bottom-left-radius: 4px;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
  box-shadow: none;
  /* Remove bubble effect */
  border: none;
  /* Remove border */
  padding-left: 0;
  /* Align text to the left edge */
  font-size: 14px;
  line-height: 1.6;
}

.message-content h1,
.message-content h2,
.message-content h3 {
  margin-top: 12px;
  margin-bottom: 8px;
  color: inherit;
}

.message-content h1:first-child,
.message-content h2:first-child,
.message-content h3:first-child {
  margin-top: 0;
}

.message-content p {
  margin-bottom: 8px;
}

.message-content p:last-child {
  margin-bottom: 0;
}

.message-content ul,
.message-content ol {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 8px;
}

.message-content a {
  color: inherit;
  text-decoration: underline;
  opacity: 0.9;
}

.message.user .message-content a {
  color: rgba(255, 255, 255, 0.9);
}

.message-content code {
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
}

.message.user .message-content code {
  background: rgba(255, 255, 255, 0.2);
}

.message-content pre {
  background: rgba(0, 0, 0, 0.05);
  padding: 12px;
  border-radius: 8px;
  overflow-x: auto;
  margin-bottom: 8px;
}

.message.user .message-content pre {
  background: rgba(255, 255, 255, 0.15);
}

.message-content pre code {
  background: none;
  padding: 0;
}

/* Agent States */
.agent-states {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
  padding: 0;
}

.agent-state {
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
  padding: 4px 8px;
  background: rgba(255, 51, 51, 0.06);
  border-radius: 4px;
  border-left: 2px solid #F33;
  animation: slideIn 0.3s ease-out;
  line-height: 1.4;
  font-family: 'Courier New', monospace;
}

.message.user .agent-state {
  background: rgba(255, 255, 255, 0.08);
  border-left-color: rgba(255, 255, 255, 0.4);
  color: rgba(255, 255, 255, 0.8);
}

.agent-state-tool_call {
  border-left-color: #3b82f6;
  background: rgba(59, 130, 246, 0.06);
}

.message.user .agent-state-tool_call {
  background: rgba(255, 255, 255, 0.08);
  border-left-color: rgba(255, 255, 255, 0.4);
}

.agent-state-tool_response {
  border-left-color: #10b981;
  background: rgba(16, 185, 129, 0.06);
}

.message.user .agent-state-tool_response {
  background: rgba(255, 255, 255, 0.08);
  border-left-color: rgba(255, 255, 255, 0.4);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

/* Typing Indicator */
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
}

.typing-text {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.message.user .typing-text {
  color: rgba(255, 255, 255, 0.9);
}

.typing-dots {
  display: flex;
  gap: 4px;
  align-items: center;
}

.typing-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #999;
  animation: typing 1.4s infinite;
}

.message.user .typing-dots span {
  background: rgba(255, 255, 255, 0.8);
}

.typing-dots span:nth-child(1) {
  animation-delay: 0s;
}

.typing-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {

  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.7;
  }

  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
}

/* Chat Input - New UI Style */
.chat-input-container {
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  background: var(--bg-white);
  border-top: 1px solid var(--border-color);
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0; /* Prevent input from being squashed */
}

.input-wrapper {
  flex: 1 1;
  position: relative;
}

.chat-input {
  width: 100%;
  padding: 14px 20px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-full);
  font-size: 1rem;
  font-family: inherit;
  resize: none;
  max-height: 120px;
  min-height: 50px;
  transition: all 0.2s;
  background: var(--bg-light);
}

.chat-input:focus {
  outline: none;
  border-color: var(--dbs-red);
  background: var(--bg-white);
  box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.1);
}

.send-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--dbs-red);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  transition: all 0.2s;
  flex-shrink: 0;
}

.send-btn:hover:not(:disabled) {
  transform: scale(1.05);
  background: var(--dbs-red-dark);
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

.send-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.send-btn i {
  font-size: 1rem;
}

.send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Settings Panel */
.settings-panel {
  position: fixed;
  top: 0;
  right: -400px;
  width: 400px;
  height: 100vh;
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease;
  z-index: 1000;
  overflow-y: auto;
}

.settings-panel.open {
  right: 0;
}

.settings-header {
  background: var(--dbs-red);
  color: white;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-header h2 {
  font-size: 18px;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-content {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #F33;
}

.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
  background: white;
}

.form-group input.error,
.form-group select.error {
  border-color: #e74c3c;
}

.error-message {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 4px;
}

.user-type-description {
  font-size: 12px;
  color: #666;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-top: 4px;
}

/* Card Section */
.card-section {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 8px;
  margin-bottom: 20px;
}

.card-section-header {
  background: #f9f9f9;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}

.card-section-header:hover {
  background: #f0f0f0;
}

.card-section-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.expand-icon {
  font-size: 20px;
  color: #666;
  font-weight: 300;
}

.card-form {
  padding: 20px;
  background: white;
}

.div-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px;
}

.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-row-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.settings-btn.save-btn {
  background: var(--dbs-red) !important;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.settings-btn.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 51, 51, 0.4);
}

.settings-btn.save-btn:active {
  transform: translateY(0);
}

.settings-btn.save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

/* Credential Link */
.credential-link {
  display: inline-block;
  margin-top: 12px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #F33 0%, #F33 100%);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.credential-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* Payment Modal */
.payment-modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  align-items: center;
  justify-content: center;
}

.payment-modal.open {
  display: flex;
}

/* Inline mode - renders as a card in the chat flow */
.payment-modal.inline {
  position: relative;
  background: transparent;
  width: 100%;
  max-width: 500px;
  height: auto;
  z-index: 1;
  animation: none;
}

.payment-modal.inline .payment-modal-content {
  margin: 0;
  width: 100%;
  max-height: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.payment-modal.inline .payment-modal-close {
  display: none;
}

/* Inline Payment Container - in chat flow */
.inline-payment-container {
  width: 100%;
  max-width: 100%;
  margin: 16px 0;
  padding: 0;
  animation: slideInUp 0.3s ease-out;
}

.inline-payment-container .payment-modal-content {
  max-width: 100%;
  width: 100%;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* New Payment Modal Design */
.payment-modal-new {
  padding: 0 !important;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}

.payment-recommendation-banner {
  background: #FFF5F5;
  border-left: 4px solid #E53935;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.payment-secure-header {
  text-align: center;
  padding: 20px 16px 8px;
}

.secure-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #E53935;
  font-weight: 600;
  font-size: 14px;
}

.shield-icon {
  font-size: 16px;
}

.countdown-timer {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.payment-price-display {
  text-align: center;
  padding: 16px;
}

.price-amount {
  font-size: 32px;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
}

.flight-routes,
.booking-routes {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.payment-card-list {
  padding: 0 16px 16px;
  width: 100%;
  box-sizing: border-box;
}

.payment-card-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.payment-card-option:hover {
  border-color: #E53935;
  background: #FFFAFA;
}

.payment-card-option.selected {
  border-color: #E53935;
  background: #FFFAFA;
}

.card-option-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-type-icon {
  width: 32px;
  height: auto;
}

.card-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.cashback-badge {
  background: #E8F5E9;
  color: #2E7D32;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
}

.add-icon {
  font-size: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F5F5;
  border-radius: 50%;
  color: #666;
  font-weight: 300;
}

.apple-pay-icon {
  width: 24px;
  height: 24px;
  color: #000;
}

.card-radio {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #E53935;
}

.payment-btn-pay-now {
  width: calc(100% - 32px);
  margin: 0 16px 16px;
  padding: 16px;
  background: #E53935;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
  box-sizing: border-box;
}

.inline-payment-container .payment-btn-pay-now {
  width: calc(100% - 32px);
}

.payment-btn-pay-now:hover {
  background: #C62828;
}

.payment-btn-pay-now:disabled {
  background: #BDBDBD;
  cursor: not-allowed;
}

/* Passenger Confirmation Loading */
.passenger-confirmation .confirmation-loading {
  padding: 40px;
  text-align: center;
  color: #666;
}

.payment-modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.payment-modal-header {
  background: linear-gradient(135deg, #F33 0%, #F33 100%);
  color: white;
  padding: 20px 24px;
  border-radius: 16px 16px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-modal-header h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.payment-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.payment-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.payment-card-container {
  padding: 20px 24px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-card {
  background: #000000;
  border-radius: 12px;
  width: 250px;
  height: 140px;
  padding: 20px;
  padding-top: 0px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.payment-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  pointer-events: none;
}

.payment-card-number {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  margin-bottom: 24px;
  margin-top: 8px;
  font-family: 'Courier New', monospace;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.payment-card-number span {
  display: inline-block;
  margin: 0 2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.payment-card-logo {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
  position: relative;
  z-index: 1;
}

.mastercard-logo {
  width: 60px;
  height: 38px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  padding: 4px;
}

.mastercard-circles {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mastercard-logo::before {
  content: '';
  position: absolute;
  width: 24px;
  height: 24px;
  background: #eb001b;
  border-radius: 50%;
  left: 8px;
  z-index: 1;
}

.mastercard-logo::after {
  content: '';
  position: absolute;
  width: 24px;
  height: 24px;
  background: #f79e1b;
  border-radius: 50%;
  right: 8px;
  z-index: 1;
}

.mastercard-text {
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 7px;
  font-weight: bold;
  color: #1a1a1a;
  letter-spacing: 0.3px;
  font-family: Arial, sans-serif;
  z-index: 2;
}

.payment-modal-body {
  padding: 24px;
}

.payment-info {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.payment-info-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
}

.payment-info-item:last-child {
  border-bottom: none;
}

.payment-info-label {
  font-weight: 600;
  color: #666;
}

.payment-info-value {
  color: #333;
}

.payment-form-group {
  margin-bottom: 20px;
}

.payment-form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.payment-form-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.payment-form-group input:focus {
  outline: none;
  border-color: #F33;
}

.payment-modal-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.payment-btn {
  flex: 1 1;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.payment-btn-confirm {
  background: linear-gradient(135deg, #F33 0%, #F33 100%);
  color: white;
}

.payment-btn-confirm:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.payment-btn-cancel {
  background: #e0e0e0;
  color: #333;
}

.payment-btn-cancel:hover:not(:disabled) {
  background: #d0d0d0;
}

.payment-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Widget Blocks (list / carousel / cards) */
.widget-blocks {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ui-block {
  background: #fafafa;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid #e5e5e5;
}

.message.user .ui-block {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.25);
}

.ui-block-title {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 8px;
}

.message.user .ui-block-title {
  color: #fff;
}

/* List style */
.ui-block-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ui-block-list-item {
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.message.assistant .ui-block-list-item {
  background: #fff;
}

.message.user .ui-block-list-item {
  background: rgba(255, 255, 255, 0.06);
  box-shadow: none;
}

.ui-block-item-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.ui-block-item-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.message.user .ui-block-item-title {
  color: #ffffff;
}

.ui-block-item-subtitle {
  font-size: 12px;
  color: #6b7280;
}

.message.user .ui-block-item-subtitle {
  color: rgba(255, 255, 255, 0.8);
}

.ui-block-item-meta {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.message.user .ui-block-item-meta {
  color: #ffffff;
}

.ui-block-item-description {
  font-size: 12px;
  color: #4b5563;
  margin-top: 2px;
}

.message.user .ui-block-item-description {
  color: rgba(255, 255, 255, 0.85);
}

.ui-block-item-tags,
.ui-block-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.ui-block-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
}

.message.user .ui-block-tag {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

/* Carousel style */
.ui-block-carousel {
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  margin: 0 -4px;
  padding-left: 4px;
  scroll-snap-type: x mandatory;
}

.ui-block-carousel::-webkit-scrollbar {
  height: 4px;
}

.ui-block-carousel::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.7);
  border-radius: 999px;
}

.ui-block-card {
  min-width: 190px;
  max-width: 220px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  scroll-snap-align: start;
}

.message.user .ui-block-card {
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);
}

.ui-block-card-image-wrapper {
  width: 100%;
  height: 120px;
  overflow: hidden;
}

.ui-block-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ui-block-card-body {
  padding: 10px 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ui-block-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.message.user .ui-block-card-title {
  color: #ffffff;
}

.ui-block-card-subtitle {
  font-size: 12px;
  color: #6b7280;
}

.message.user .ui-block-card-subtitle {
  color: rgba(255, 255, 255, 0.8);
}

.ui-block-card-description {
  font-size: 12px;
  color: #4b5563;
}

.message.user .ui-block-card-description {
  color: rgba(255, 255, 255, 0.85);
}

.ui-block-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
}

.ui-block-card-price {
  font-size: 13px;
  font-weight: 700;
  color: #16a34a;
}

.message.user .ui-block-card-price {
  color: #4ade80;
}

.ui-block-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

@media (max-width: 768px) {
  .ui-block-card {
    min-width: 160px;
  }

   .a2ui-row-line-row {
    display: block;
   
  }
   .a2ui-list-item {
    display: block;
   }
}

/* A2UI Components Styles */
.a2ui-renderer {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Animation for newly added components */
.component-newly-added {
  animation: componentSlideIn 0.4s ease-out;
  opacity: 0;
  animation-fill-mode: forwards;
}

@keyframes componentSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Stagger animation for multiple components */
.a2ui-renderer>*:nth-child(1).component-newly-added {
  animation-delay: 0s;
}

.a2ui-renderer>*:nth-child(2).component-newly-added {
  animation-delay: 0.05s;
}

.a2ui-renderer>*:nth-child(3).component-newly-added {
  animation-delay: 0.1s;
}

.a2ui-renderer>*:nth-child(4).component-newly-added {
  animation-delay: 0.15s;
}

.a2ui-renderer>*:nth-child(n+5).component-newly-added {
  animation-delay: 0.2s;
}

/* A2UI Text */
.a2ui-text {
  font-size: 14px;
  color: inherit;
  line-height: 1.5;
}

/* A2UI Button */
.a2ui-button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-block;
}

.a2ui-button-primary {
  background: var(--dbs-red);
  color: white;
  border: 1px solid var(--dbs-red);
  font-weight: 500;
}

.a2ui-button-primary:hover {
  background: var(--dbs-red-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

.a2ui-button-secondary {
  background: var(--bg-light);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  font-weight: 500;
}

.a2ui-button-secondary:hover {
  background: var(--bg-white);
  border-color: var(--dbs-red);
  color: var(--dbs-red);
}

.a2ui-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.message.user .a2ui-button-primary {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.message.user .a2ui-button-primary:hover {
  background: rgba(255, 255, 255, 0.3);
}

.message.user .a2ui-button-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-color: rgba(255, 255, 255, 0.2);
}

/* A2UI List */
.a2ui-list {
  background: var(--bg-white);
  border-radius: var(--radius-md);
  padding: 12px 14px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.message.user .a2ui-list {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.25);
}

.a2ui-list-title {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 8px;
}

.message.user .a2ui-list-title {
  color: #fff;
}

.a2ui-list-items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.a2ui-list-item {
  background: var(--bg-white);
  border-radius: var(--radius-sm);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s;
  border: 1px solid var(--border-color);
}

/* List item with image - horizontal layout */
.a2ui-list-item.a2ui-list-item-with-image {
  flex-direction: row;
  gap: 12px;
  padding: 12px;
}

.a2ui-list-item-image-wrapper {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  align-self: center; /* vertical center within list item row */
  border-radius: 8px;
  overflow: hidden;
}

.a2ui-list-item-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.a2ui-list-item-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  /* Allow text truncation */
}

.a2ui-list-item.a2ui-clickable {
  cursor: pointer;
}

.a2ui-list-item.a2ui-clickable:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--dbs-red);
}

.message.assistant .a2ui-list-item {
  background: #fff;
}

.message.user .a2ui-list-item {
  background: rgba(255, 255, 255, 0.06);
  box-shadow: none;
}

.message.user .a2ui-list-item.a2ui-clickable:hover {
  background: rgba(255, 255, 255, 0.1);
}

.message.user .a2ui-list-item-image-wrapper {
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.a2ui-list-item-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.a2ui-row-lines {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: #f8f8f8;
  border-radius: 5px;
  padding: 4px 8px;
}

.a2ui-row-line-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  column-gap: 12px;
  min-width: 0;
}

.a2ui-row-cell {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.a2ui-row-cell-left {
  justify-self: start;
}

.a2ui-row-cell-middle {
  justify-self: center;
  text-align: center;
  padding: 0 6px;
  color: var(--text-secondary);
  font-weight: 400;
  white-space: nowrap;
}

.a2ui-row-cell-right {
  justify-self: end;
  text-align: right;
}

.a2ui-row-line-1 .a2ui-row-cell {
  font-size: 12px;
  font-weight: 600;
  color: #111827;
}

.a2ui-row-line-2 .a2ui-row-cell {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 400;
}

.message.user .a2ui-row-line-1 .a2ui-row-cell {
  color: #ffffff;
}

.message.user .a2ui-row-line-2 .a2ui-row-cell {
  color: rgba(255, 255, 255, 0.8);
}

.message.user .a2ui-row-cell-middle {
  color: rgba(255, 255, 255, 0.75);
}

.a2ui-link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid rgba(227, 24, 55, 0.35);
  color: var(--dbs-red);
  background: rgba(227, 24, 55, 0.06);
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.a2ui-link-btn:hover {
  background: rgba(227, 24, 55, 0.12);
  border-color: rgba(227, 24, 55, 0.55);
}

.message.user .a2ui-link-btn {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.12);
}

.message.user .a2ui-link-btn:hover {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.5);
}

.a2ui-list-item-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.message.user .a2ui-list-item-title {
  color: #ffffff;
}

.a2ui-list-item-subtitle {
  font-size: 12px;
  color: var(--text-secondary);
}

.message.user .a2ui-list-item-subtitle {
  color: rgba(255, 255, 255, 0.8);
}

.a2ui-list-item-meta {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  /* Vertically center meta content (e.g., link/price/button) */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
}

.message.user .a2ui-list-item-meta {
  color: #ffffff;
}

.a2ui-list-item-description {
  font-size: 14px;
  color: var(--text-secondary);
  margin-top: 2px;
}

.message.user .a2ui-list-item-description {
  color: rgba(255, 255, 255, 0.85);
}

.a2ui-list-item-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.a2ui-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
}

.message.user .a2ui-tag {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.a2ui-list-item-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.a2ui-list-item-action-btn {
  padding: 6px 12px;
  font-size: 12px;
}

/* Smart Mapping: Enhanced styles for flight/hotel content */
.a2ui-list-flight-enhanced .a2ui-list-item,
.a2ui-card-flight-enhanced .a2ui-card {
  border-left: 3px solid var(--dbs-red);
  padding-left: 11px;
  /* Adjust for border */
}

.a2ui-list-hotel-enhanced .a2ui-list-item,
.a2ui-card-hotel-enhanced .a2ui-card {
  border-left: 3px solid #4caf50;
  padding-left: 11px;
  /* Adjust for border */
}

.a2ui-list-flight-enhanced .a2ui-list-item-title,
.a2ui-card-flight-enhanced .a2ui-card-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.a2ui-list-flight-enhanced .a2ui-list-item-title::before {
  content: '✈️';
  font-size: 1rem;
}

.a2ui-list-hotel-enhanced .a2ui-list-item-title,
.a2ui-card-hotel-enhanced .a2ui-card-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.a2ui-list-hotel-enhanced .a2ui-list-item-title::before {
  content: '🏨';
  font-size: 1rem;
}

/* A2UI Card Container */
.a2ui-card-container {
 
  padding: 12px 14px;
 
}

.message.user .a2ui-card-container {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.25);
}

.a2ui-card-container>.a2ui-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
}

.message.user .a2ui-card-container>.a2ui-card-title {
  color: #fff;
}

.a2ui-card-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* A2UI Card */
.a2ui-card {
  min-width: 190px;
 
  background: var(--bg-white);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  display: flex;
  transition: all 0.2s;
  border: 1px solid var(--border-color);
}

.a2ui-card.a2ui-card-full-width {
  width: 100%;
  flex-basis: 100%;
}

.a2ui-card.a2ui-clickable {
  cursor: pointer;
}

.a2ui-card.a2ui-clickable:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
  border-color: var(--dbs-red);
}

.message.user .a2ui-card {
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);
}

.message.user .a2ui-card.a2ui-clickable:hover {
  background: rgba(255, 255, 255, 0.12);
}

.a2ui-card-image-wrapper {
  width: 140px;
 height: 140px;
  overflow: hidden;
  padding: 12px;
}

.a2ui-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}

.a2ui-card-body {
  width: 90%;
  padding: 10px 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.a2ui-card-body.a2ui-card-body-fullwidth {
  width: 100%;
}

.a2ui-card-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  padding: 0 5px;
}

.message.user .a2ui-card-title {
  color: #ffffff;
}

.a2ui-card-subtitle {
  font-size: 14px;
  color: #6b7280;
  padding: 0 5px;
}

.message.user .a2ui-card-subtitle {
  color: rgba(255, 255, 255, 0.8);
}

.a2ui-card-description {
  font-size: 12px;
  color: var(--text-secondary);
}

.message.user .a2ui-card-description {
  color: rgba(255, 255, 255, 0.85);
}

.a2ui-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
}

.a2ui-card-price {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--dbs-red);
  /* 使用 DBS Red 作为价格颜色 */
  margin-left: auto;
  text-align: right;
}

.message.user .a2ui-card-price {
  color: rgba(255, 255, 255, 0.95);
}

.a2ui-card-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.a2ui-card-action-btn {
  padding: 6px 12px;
  font-size: 12px;
}

/* A2UI Carousel */
.a2ui-carousel {
  background: #fafafa;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid #e5e5e5;
}

.message.user .a2ui-carousel {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.25);
}

.a2ui-carousel-title {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
}

.message.user .a2ui-carousel-title {
  color: #fff;
}

.a2ui-carousel-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  margin: 0 -4px;
  padding-left: 4px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}

.a2ui-carousel-container::-webkit-scrollbar {
  height: 4px;
}

.a2ui-carousel-container::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.7);
  border-radius: 999px;
}

.a2ui-carousel-container::-webkit-scrollbar-track {
  background: transparent;
}

.a2ui-carousel-card {
  scroll-snap-align: start;
  flex-shrink: 0;
}

/* A2UI Form */
.a2ui-form {
  background: var(--bg-white);
  border-radius: var(--radius-md);
  padding: 16px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.message.user .a2ui-form {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.25);
}

.a2ui-form-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.message.user .a2ui-form-title {
  color: #fff;
}

.a2ui-form-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.a2ui-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.a2ui-input-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.message.user .a2ui-input-label {
  color: rgba(255, 255, 255, 0.9);
}

.a2ui-input,
.a2ui-select {
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 14px;
  background: var(--bg-white);
  color: var(--text-primary);
  transition: all 0.2s;
  font-family: 'Outfit', inherit;
}

.a2ui-input:focus,
.a2ui-select:focus {
  outline: none;
  border-color: var(--dbs-red);
  box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.1);
}

.message.user .a2ui-input,
.message.user .a2ui-select {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.message.user .a2ui-input:focus,
.message.user .a2ui-select:focus {
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
}

.a2ui-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.a2ui-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
}

.message.user .a2ui-checkbox-label {
  color: rgba(255, 255, 255, 0.9);
}

.a2ui-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--dbs-red);
}

.a2ui-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* A2UI Container */
.a2ui-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Responsive */
@media (max-width: 768px) {
  .chat-container {
    height: 100%;
    max-width: 100%;
  }

  /* User messages: right-aligned, max 85% width on mobile */
  .message.user .message-content {
    max-width: 85%;
  }

  /* AI messages: left-aligned, full width (100%) on mobile */
  .message.assistant .message-content {
    width: 100%;
    max-width: 100%;
  }

  .settings-panel {
    width: 100%;
    right: -100%;
  }

  .a2ui-card,
  .a2ui-carousel-card {
    min-width: 160px;
  }

  /* Optimize list item image for mobile */
  .a2ui-list-item-image-wrapper {
    width: 70px;
    height: 70px;
  }

  .a2ui-list-item.a2ui-list-item-with-image {
    gap: 10px;
    padding: 10px;
    display: block;
  }
}

/* ==================== Travel-Specific Components ==================== */

/* Flight Card - Compact layout for 5-6 options per screen */
.flight-card {
  background: var(--bg-white);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  padding: 0.625rem 0.75rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.flight-card:hover {
  border-color: var(--dbs-red);
  box-shadow: var(--shadow-sm);
}

.flight-card.selected {
  border-color: var(--dbs-red);
  background: rgba(255, 0, 0, 0.02);
}

.flight-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.375rem;
  border-bottom: 1px solid var(--border-color);
}

.flight-airline {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.airline-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.airline-name {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-primary);
}

.flight-number {
  color: var(--text-secondary);
  font-size: 0.8rem;
}

.flight-price {
  text-align: right;
  display: flex;
  align-items: baseline;
  gap: 0.125rem;
}

.flight-price .price-currency {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.flight-price .price-amount {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--dbs-red);
}

.flight-price .price-per {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.flight-card-body {
  padding: 0.25rem 0;
}

.flight-route {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.route-point {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.route-point.departure {
  text-align: left;
}

.route-point.arrival {
  text-align: right;
}

.route-time {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.route-code {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
}

.route-city {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.route-line {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
}

.route-duration {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.route-visual {
  display: flex;
  align-items: center;
  width: 100%;
}

.route-visual .dot {
  width: 6px;
  height: 6px;
  background: var(--dbs-red);
  border-radius: 50%;
}

.route-visual .line {
  flex: 1 1;
  height: 1px;
  background: var(--border-color);
}

.route-visual .stop-indicator {
  padding: 0 0.375rem;
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.route-stops {
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.route-stops.nonstop {
  color: #4caf50;
  font-weight: 500;
}

/* Hide flight details by default to save space - shown inline in header */
.flight-details {
  display: none;
}

.flight-details .cabin-class,
.flight-details .aircraft {
  font-size: 0.75rem;
  color: var(--text-secondary);
  background: var(--bg-light);
  padding: 0.125rem 0.375rem;
  border-radius: var(--radius-sm);
}

.flight-card-footer {
  margin-top: 0.5rem;
  padding-top: 0.375rem;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
}

.flight-card-footer .a2ui-button {
  padding: 0.375rem 0.75rem;
  font-size: 0.8rem;
}

/* Hotel List Item */
.hotel-list-item {
  background: var(--bg-white);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  display: flex;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0.5rem;
}

.hotel-list-item:hover {
  border-color: var(--dbs-red);
  box-shadow: var(--shadow-md);
}

.hotel-list-item.selected {
  border-color: var(--dbs-red);
  background: rgba(255, 0, 0, 0.02);
}

.hotel-image-wrapper {
  width: 140px;
  height: 140px;
  position: relative;
  flex-shrink: 0;
}

.hotel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
}

.hotel-discount-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: var(--dbs-red);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 600;
}

.hotel-content {
  flex: 1 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.hotel-header {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.25rem;
}

.hotel-title-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.hotel-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.125rem 0;
}

.hotel-stars {
  display: flex;
  gap: 2px;
  color: #ffc107;
  font-size: 0.75rem;
}

.hotel-rating {
  background: #4caf50;
  color: white;
  padding: 0.15rem 0.4rem;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 600;
}

.hotel-location {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.hotel-location i {
  margin-right: 0.25rem;
}

.hotel-description {
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hotel-amenities {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.amenity-tag {
  background: var(--bg-light);
  color: var(--text-secondary);
  padding: 0.2rem 0.5rem;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
}

.amenity-more {
  color: var(--text-muted);
  font-size: 0.75rem;
}

.hotel-room-type {
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-style: italic;
}

.hotel-price-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  padding: 1rem;
  min-width: 140px;
  border-left: 1px solid var(--border-color);
}

.hotel-price {
  text-align: right;
}

.hotel-price .original-price {
  font-size: 0.85rem;
  color: var(--text-muted);
  text-decoration: line-through;
  display: block;
}

.hotel-price .current-price {
  color: var(--dbs-red);
}

.hotel-price .price-amount {
  font-size: 1.4rem;
  font-weight: 700;
}

.hotel-price .price-per {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

/* Destination Carousel - 匹配新UI设计 */
.destination-carousel {
  padding: 0.5rem 0.2rem 1rem 0.2rem;
  width: 100%;
  /* Hide scrollbar for cleaner look */
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.destination-carousel::-webkit-scrollbar {
  display: none;
}

.carousel-mid-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 1rem 0 0.5rem 0.2rem;
  color: var(--text-primary);
}

.destination-carousel-container {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding: 0.5rem 0.2rem 1rem 0.2rem;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.destination-carousel-container::-webkit-scrollbar {
  display: none;
}

.carousel-card {
  min-width: 200px;
  width: 200px;
  background: var(--bg-white);
  border-radius: var(--radius-md);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  border: 1px solid #eee;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
}

.carousel-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.carousel-image {
  height: 120px;
  width: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

/* Gradient overlay for text readability */
.carousel-image::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
}

.carousel-city-name {
  position: absolute;
  bottom: 10px;
  left: 12px;
  color: white;
  font-weight: 700;
  font-size: 1.1rem;
  z-index: 2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.deal-badge {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: #e6f4ea;
  color: #137333;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  z-index: 2;
}

.typical-badge {
  background: #f1f3f4;
  color: #5f6368;
}

.carousel-content {
  padding: 0.8rem;
}

.carousel-food {
  font-size: 0.8rem;
  color: #444;
  margin-bottom: 0.3rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.carousel-food i {
  color: #aa1f1f;
  font-size: 0.7rem;
}

.carousel-dates {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}

.carousel-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.carousel-from {
  font-size: 0.7rem;
  color: #888;
}

.carousel-price {
  font-size: 1rem;
  font-weight: 700;
  color: var(--dbs-red);
}

/* Suggestion Chips */
.suggestion-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.5rem 0;
}

.suggestion-chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-full);
  cursor: pointer;
  font-size: 0.9rem;
  color: var(--text-primary);
  transition: all 0.2s ease;
  font-family: inherit;
}

.suggestion-chip:hover {
  border-color: var(--dbs-red);
  background: rgba(255, 0, 0, 0.02);
}

.suggestion-chip i {
  color: var(--dbs-red);
  font-size: 0.85rem;
}

/* Itinerary Card */
.itinerary-card {
  background: var(--bg-white);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  padding: 1.25rem;
  margin-bottom: 0.75rem;
}

.itinerary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.itinerary-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  color: var(--text-primary);
}

.itinerary-status {
  padding: 0.25rem 0.75rem;
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.itinerary-status.confirmed {
  background: #e8f5e9;
  color: #4caf50;
}

.itinerary-status.pending {
  background: #fff3e0;
  color: #ff9800;
}

.itinerary-status.cancelled {
  background: #ffebee;
  color: #f44336;
}

.itinerary-dates {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

.confirmation-number {
  display: flex;
  gap: 0.5rem;
  font-size: 0.85rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background: var(--bg-light);
  border-radius: var(--radius-sm);
}

.confirmation-number .label {
  color: var(--text-secondary);
}

.confirmation-number .value {
  font-weight: 600;
  color: var(--text-primary);
  font-family: monospace;
}

.itinerary-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 0;
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

.itinerary-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.itinerary-item i {
  width: 24px;
  color: var(--dbs-red);
}

.itinerary-item .item-content {
  flex: 1 1;
}

.itinerary-item .item-title {
  font-weight: 600;
  color: var(--text-primary);
  display: block;
}

.itinerary-item .item-subtitle {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.itinerary-item .item-price {
  font-weight: 600;
  color: var(--text-primary);
}

.itinerary-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
}

.itinerary-footer .total-price {
  display: flex;
  flex-direction: column;
}

.itinerary-footer .total-price .label {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.itinerary-footer .total-price .value {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--dbs-red);
}

.itinerary-actions {
  display: flex;
  gap: 0.5rem;
}

/* Landing mode specific */
.App.landing-mode {
  background: var(--bg-white);
  overflow-y: auto;
}

@media (max-width: 590) {

 

}
/* ==================== Mobile Responsive Optimizations ==================== */

@media (max-width: 480px) {


  /* Landing View Mobile */
  .landing-navbar {
    padding: 0.75rem 4%;
  }

  .nav-logo {
    height: 40px;
  }

  .hero-title {
    font-size: 1.6rem;
    line-height: 1.3;
  }

  .hero-subtitle {
    font-size: 0.95rem;
    flex-wrap: wrap;
    justify-content: center;
  }

  .departure-options {
    min-width: 280px;
    left: 50%;
    transform: translateX(-50%) translateY(10px);
  }

  .search-input {
    padding: 1rem;
    font-size: 1rem;
  }

  .trip-filters {
    gap: 0.5rem;
    padding: 0 0.5rem;
  }

  .filter-group {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }

  .filter-popup {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    border-radius: 20px 20px 0 0;
    animation: slideUpMobile 0.3s ease;
  }

  @keyframes slideUpMobile {
    from {
      transform: translateY(100%);
    }

    to {
      transform: translateY(0);
    }
  }

  .cards-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .travel-card {
    flex-direction: column;
    height: auto;
  }

  .card-image-wrapper {
    width: 100%;
    height: 160px;
  }

  .pricing-row {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
  }

  /* Chat View Mobile */
  .chat-header {
    padding: 10px 12px;
  }

  .chat-header h1 {
    font-size: 16px;
  }

  .back-btn {
    width: 32px;
    height: 32px;
  }

  .chat-input-container {
    padding: 10px 12px;
  }

  .chat-input {
    padding: 10px 12px;
    font-size: 14px;
  }

  .send-btn {
    width: 40px;
    height: 40px;
  }

  /* Flight Card Mobile */
  .flight-card {
    padding: 0.5rem;
  }

  .flight-route {
    flex-direction: row;
    gap: 0.5rem;
  }

  .route-point {
    text-align: left;
  }

  .route-point.arrival {
    text-align: right;
  }

  .route-line {
    flex: 1 1;
    flex-direction: column;
    justify-content: center;
  }

  .route-visual {
    width: 100%;
    min-width: 100px;
  }

  /* Hotel List Item Mobile */
  .hotel-list-item {
    flex-direction: column;
  }

  .hotel-image-wrapper {
    width: 100%;
    height: 180px;
  }

  .hotel-price-section {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-left: none;
    border-top: 1px solid var(--border-color);
    padding: 1rem;
    min-width: auto;
  }

  /* Destination Carousel Mobile */
  .destination-card {
    min-width: 200px;
  }

  /* Suggestion Chips Mobile */
  .suggestion-chips {
    gap: 0.5rem;
  }

  .suggestion-chip {
    padding: 0.4rem 0.75rem;
    font-size: 0.85rem;
  }
}

/* Tablet Optimizations */
@media (min-width: 481px) and (max-width: 1024px) {
  .landing-main {
    padding: 0 4%;
  }

  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .flight-route {
    gap: 0.75rem;
  }
}

/* High Resolution / Large Screen */
@media (min-width: 1440px) {
  .landing-main {
    max-width: 1600px;
  }

  .hero-title {
    font-size: 3.2rem;
  }

  .search-container {
    max-width: 750px;
  }

  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Dark Mode Support (optional - follows system preference) */
@media (prefers-color-scheme: dark) {
  /* Uncomment to enable dark mode
  :root {
    --text-primary: #f5f5f5;
    --text-secondary: #b0b0b0;
    --text-muted: #808080;
    --bg-white: #1a1a1a;
    --bg-light: #2a2a2a;
    --bg-chat: #242424;
    --border-color: #404040;
  }
  */
}

/* Print Styles for Booking Confirmation */
@media print {
  .booking-confirmation {
    box-shadow: none;
    border: 1px solid #ddd;
  }

  .confirmation-actions,
  .return-home {
    display: none;
  }

  .confirmation-header {
    background: #4caf50 !important;
    print-color-adjust: exact;
  }
}

/* ========================================
   Flight Booking Summary Component
   ======================================== */
.flight-booking-summary {
  background: var(--bg-white);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  overflow: hidden;
  margin-bottom: 1rem;
}

.flight-booking-summary .summary-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-light);
}

.flight-booking-summary .header-icon {
  font-size: 1rem;
}

.flight-booking-summary .header-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--text-primary);
}

/* Flight Leg */
.flight-booking-summary .flight-leg {
  padding: 1rem;
}

.flight-booking-summary .flight-leg-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.flight-booking-summary .airline-logo-summary {
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 4px;
}

.flight-booking-summary .flight-number-summary {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary, #666);
}

.flight-booking-summary .flight-meta {
  margin-left: auto;
  font-size: 0.75rem;
  color: var(--text-secondary, #666);
}

.flight-booking-summary .airline-tag {
  background: linear-gradient(135deg, #f5e6a3 0%, #d4af37 100%);
  color: #5c4b00;
  padding: 0.25rem 0.625rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.flight-booking-summary .flight-meta {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

/* Flight Times */
.flight-booking-summary .flight-times {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.flight-booking-summary .time-point {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.flight-booking-summary .time-point.departure {
  text-align: left;
  min-width: 60px;
}

.flight-booking-summary .time-point.arrival {
  text-align: right;
  min-width: 60px;
}

.flight-booking-summary .time-point .time {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.2;
}

.flight-booking-summary .time-point .time sup {
  font-size: 0.7rem;
  color: var(--dbs-red);
  font-weight: 600;
  margin-left: 2px;
}

.flight-booking-summary .time-point .airport {
  font-size: 0.8rem;
  color: #5db8a3;
  font-weight: 500;
}

.flight-booking-summary .time-line {
  flex: 1 1;
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
}

.flight-booking-summary .time-line .line {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(90deg, #d4af37 0%, #d4af37 100%);
}

/* Leg Divider */
.flight-booking-summary .leg-divider {
  height: 1px;
  background: var(--border-color);
  margin: 0;
}

/* Total Price Row */
.flight-booking-summary .total-price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 1rem;
  border-top: 1px solid var(--border-color);
  background: var(--bg-light);
}

.flight-booking-summary .total-label {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 0.9rem;
}

.flight-booking-summary .total-amount {
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--text-primary);
}

/* Action Buttons */
.flight-booking-summary .summary-actions {
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid var(--border-color);
}

.flight-booking-summary .btn-confirm-pay {
  flex: 2 1;
  padding: 0.75rem 1rem;
  background: var(--dbs-red);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.flight-booking-summary .btn-confirm-pay:hover {
  background: var(--dbs-red-dark);
  transform: translateY(-1px);
}

.flight-booking-summary .btn-edit {
  flex: 1 1;
  padding: 0.75rem 1rem;
  background: var(--bg-white);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.flight-booking-summary .btn-edit:hover {
  background: var(--bg-light);
  border-color: var(--text-secondary);
}

/* Responsive */
@media (max-width: 480px) {
  .flight-booking-summary .time-point .time {
    font-size: 1.25rem;
  }

  .flight-booking-summary .summary-actions {
    flex-direction: column;
  }

  .flight-booking-summary .btn-confirm-pay,
  .flight-booking-summary .btn-edit {
    flex: none;
    width: 100%;
  }
}

/* ===========================================
   FlightReceipt Component - Compact Design (max 60% viewport)
   =========================================== */

.flight-receipt {
  width: 90%;

  max-height: 65vh;
  margin: 0.75rem auto;
  background: var(--bg-white, #fff);
  border-radius: var(--radius-lg, 12px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  overflow-y: auto;
}

.flight-receipt .receipt-header {
  background: linear-gradient(135deg, #E53935 0%, #C62828 100%);
  color: white;
  padding: 1rem 1.25rem;
  text-align: center;
}

.flight-receipt .success-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  font-weight: bold;
}

.flight-receipt .receipt-title {
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
  font-weight: 700;
}

.flight-receipt .receipt-subtitle {
  margin: 0;
  font-size: 0.8rem;
  opacity: 0.9;
}

.flight-receipt .receipt-reference {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: var(--bg-light, #f8f9fa);
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

.flight-receipt .reference-item {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.flight-receipt .reference-item .label {
  font-size: 0.65rem;
  color: var(--text-secondary, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.flight-receipt .reference-item .value {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
}

.flight-receipt .reference-code {
  font-family: monospace;
  font-size: 1rem;
  letter-spacing: 0.15em;
  color: var(--dbs-red, #e31837);
}

.flight-receipt .status-badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 500;
}

.flight-receipt .status-badge.confirmed {
  background: #d1fae5;
  color: #059669;
}

.flight-receipt .status-badge.pending {
  background: #fef3c7;
  color: #d97706;
}

/* Compact Flight Legs */
.flight-receipt .receipt-flights {
  padding: 0.75rem 1rem;
}

.flight-receipt .receipt-flight-leg {
  padding: 0.5rem 0;
  border-bottom: 1px dashed var(--border-color, #e5e7eb);
}

.flight-receipt .receipt-flight-leg:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.flight-receipt .leg-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.flight-receipt .leg-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--text-secondary, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.flight-receipt .leg-flight-info {
  font-size: 0.75rem;
  color: var(--text-secondary, #6b7280);
}

.flight-receipt .leg-route-compact {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.flight-receipt .route-point {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flight-receipt .route-point .time {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary, #111827);
}

.flight-receipt .route-point .time .next-day {
  font-size: 0.55rem;
  color: var(--dbs-red, #e31837);
  vertical-align: super;
  margin-left: 2px;
}

.flight-receipt .route-point .code {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-secondary, #6b7280);
}

.flight-receipt .route-arrow-compact {
  font-size: 1rem;
  color: var(--text-muted, #9ca3af);
  padding: 0 0.5rem;
}

.flight-receipt .duration-compact {
  font-size: 0.7rem;
  color: var(--text-muted, #9ca3af);
  margin-left: auto;
  background: linear-gradient(to right, transparent, var(--border-color, #e5e7eb), transparent);
}

.flight-receipt .route-arrow .arrow-head {
  font-size: 1.25rem;
}

.flight-receipt .leg-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.flight-receipt .meta-item {
  font-size: 0.85rem;
  color: var(--text-secondary, #6b7280);
}

.flight-receipt .meta-divider {
  color: var(--text-muted, #9ca3af);
  font-size: 0.6rem;
}

.flight-receipt .receipt-passenger {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: var(--bg-light, #f8f9fa);
  border-top: 1px solid var(--border-color, #e5e7eb);
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

.flight-receipt .receipt-passenger .label {
  font-size: 0.85rem;
  color: var(--text-secondary, #6b7280);
}

.flight-receipt .receipt-passenger .value {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
}

/* Compact Payment Summary */
.flight-receipt .receipt-payment {
  padding: 0.75rem 1rem;
  background: var(--bg-light, #f8f9fa);
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.flight-receipt .payment-row.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  margin-bottom: 0.5rem;
}

.flight-receipt .payment-row.total .total-amount {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--dbs-red, #e31837);
}

.flight-receipt .payment-card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
}

.flight-receipt .payment-card-row .card-info {
  color: var(--text-secondary, #6b7280);
}

.flight-receipt .payment-card-row .card-benefit {
  background: #dbeafe;
  color: #1d4ed8;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.7rem;
}

/* Hotel Receipt Styles */
.hotel-receipt .receipt-header {
  text-align: center;
  padding: 1.5rem 1rem 1rem 1rem;
  background: linear-gradient(135deg, #E53935 0%, #C62828 100%);
  color: white;
}

.hotel-receipt .success-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem auto;
  font-size: 1.5rem;
}

.hotel-receipt .receipt-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
}

.hotel-receipt .receipt-subtitle {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 0;
}

.hotel-receipt .hotel-image-section {
  width: 100%;
  height: 120px;
  overflow: hidden;
  position: relative;
}

.hotel-receipt .receipt-reference {
  padding: 1rem;
  background: var(--bg-light, #f8f9fa);
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

.hotel-receipt .reference-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hotel-receipt .reference-label {
  font-size: 0.85rem;
  color: var(--text-secondary, #6b7280);
  font-weight: 500;
}

.hotel-receipt .reference-value {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary, #111827);
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
}

.hotel-receipt .receipt-body {
  padding: 1rem;
}

.hotel-receipt .hotel-details-section {
  margin-bottom: 1.5rem;
}

.hotel-receipt .section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary, #111827);
  margin: 0 0 0.75rem 0;
  display: flex;
  align-items: center;
}

.hotel-receipt .hotel-info {
  margin-bottom: 1rem;
}

.hotel-receipt .info-row {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: var(--text-primary, #111827);
  margin-bottom: 0.5rem;
}

.hotel-receipt .amenities-section {
  margin-top: 1rem;
}

.hotel-receipt .amenities-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.hotel-receipt .amenity-tag {
  background: #f0f9ff;
  color: #0369a1;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.hotel-receipt .stay-details-section {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--bg-light, #f8f9fa);
  border-radius: 8px;
}

.hotel-receipt .subsection-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  margin: 0 0 0.75rem 0;
}

.hotel-receipt .stay-info .date-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.hotel-receipt .date-item {
  text-align: center;
  flex: 1 1;
}

.hotel-receipt .date-label {
  font-size: 0.8rem;
  color: var(--text-secondary, #6b7280);
  display: block;
  margin-bottom: 0.25rem;
}

.hotel-receipt .date-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
}

.hotel-receipt .date-separator {
  margin: 0 1rem;
  color: var(--text-secondary, #6b7280);
}

.hotel-receipt .nights-info {
  text-align: center;
  font-size: 0.85rem;
  color: var(--text-secondary, #6b7280);
  font-weight: 500;
}

.hotel-receipt .guest-section {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--bg-light, #f8f9fa);
  border-radius: 8px;
}

.hotel-receipt .guest-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
}

.hotel-receipt .receipt-payment {
  padding: 1rem;
  background: var(--bg-light, #f8f9fa);
  border-radius: 8px;
  margin-bottom: 1rem;
}

.hotel-receipt .payment-row.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  margin-bottom: 0.5rem;
}

.hotel-receipt .payment-row.total .total-amount {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--dbs-red, #e31837);
}

.hotel-receipt .payment-card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
}

.hotel-receipt .payment-card-row .card-info {
  color: var(--text-secondary, #6b7280);
}

.hotel-receipt .payment-card-row .card-benefit {
  background: #dbeafe;
  color: #1d4ed8;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.7rem;
}

.hotel-receipt .receipt-footer {
  padding: 1rem;
  background: var(--bg-light, #f8f9fa);
  border-top: 1px solid var(--border-color, #e5e7eb);
  text-align: center;
}

.hotel-receipt .footer-note {
  font-size: 0.8rem;
  color: var(--text-secondary, #6b7280);
  margin: 0 0 0.5rem 0;
}

.hotel-receipt .status-badge {
  display: inline-block;
}

.hotel-receipt .status {
  background: #dcfce7;
  color: #166534;
  padding: 0.25rem 0.75rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.hotel-receipt .status.confirmed {
  background: #dcfce7;
  color: #166534;
}

.hotel-receipt .status.pending {
  background: #fef3c7;
  color: #92400e;
}

.hotel-receipt .status.cancelled {
  background: #fee2e2;
  color: #dc2626;
}

/* Room Type Selector Styles */
.room-type-selector .room-selector-header {
  padding: 1.5rem 1rem 1rem 1rem;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
}

.room-type-selector .selector-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-primary, #111827);
  margin: 0 0 0.25rem 0;
}

.room-type-selector .selector-subtitle {
  font-size: 0.9rem;
  color: var(--text-secondary, #6b7280);
  margin: 0 0 0.75rem 0;
}

.room-type-selector .stay-summary {
  margin-top: 0.5rem;
}

.room-type-selector .stay-dates {
  font-size: 0.85rem;
  color: var(--text-secondary, #6b7280);
  font-weight: 500;
}

.room-type-selector .room-options {
  padding: 1rem;
}

.room-type-selector .room-option {
  position: relative;
  transition: all 0.2s ease;
}

.room-type-selector .room-option:hover {
  border-color: #e31837 !important;
  box-shadow: 0 2px 8px rgba(227, 24, 55, 0.1);
}

.room-type-selector .room-option.selected {
  box-shadow: 0 2px 12px rgba(227, 24, 55, 0.15);
}

.room-type-selector .room-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.room-type-selector .room-info {
  flex: 1 1;
  margin-right: 1rem;
}

.room-type-selector .room-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  margin: 0 0 0.25rem 0;
}

.room-type-selector .room-details {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: var(--text-secondary, #6b7280);
}

.room-type-selector .separator {
  margin: 0 0.5rem;
}

.room-type-selector .room-price {
  text-align: right;
  min-width: 100px;
}

.room-type-selector .price-per-night {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  margin-bottom: 0.25rem;
}

.room-type-selector .per-night {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--text-secondary, #6b7280);
}

.room-type-selector .total-price {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--dbs-red, #e31837);
}

.room-type-selector .room-features {
  margin-top: 0.75rem;
}

.room-type-selector .features-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.room-type-selector .feature-tag {
  background: #f0f9ff;
  color: #0369a1;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.room-type-selector .selection-indicator {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.room-type-selector .radio-circle {
  width: 20px;
  height: 20px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.room-type-selector .radio-circle.selected {
  background: #e31837;
  border-color: #e31837;
}

.room-type-selector .room-selector-footer {
  padding: 1rem;
  background: var(--bg-light, #f8f9fa);
  border-top: 1px solid var(--border-color, #e5e7eb);
  text-align: center;
}

.room-type-selector .footer-note {
  font-size: 0.8rem;
  color: var(--text-secondary, #6b7280);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Compact Footer */
.flight-receipt .receipt-footer {
  padding: 0.625rem 1rem;
  background: var(--bg-white, #fff);
  text-align: center;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.flight-receipt .footer-note {
  margin: 0;
  font-size: 0.7rem;
  color: var(--text-muted, #9ca3af);
}

/* Responsive - Compact Receipt */
@media (max-width: 480px) {
  .flight-receipt {
    width: 95%;
    max-height: 55vh;
    margin: 0.5rem auto;
  }

  .flight-receipt .receipt-header {
    padding: 0.75rem;
  }

  .flight-receipt .success-icon {
    width: 32px;
    height: 32px;
    font-size: 1rem;
  }

  .flight-receipt .receipt-title {
    font-size: 1rem;
  }

  .flight-receipt .receipt-subtitle {
    font-size: 0.7rem;
  }

  .flight-receipt .receipt-reference {
    padding: 0.5rem 0.75rem;
  }

  .flight-receipt .route-point .time {
    font-size: 1rem;
  }
}

/* ================================================
   FLIGHT DATE SELECTOR STYLES
   ================================================ */

.flight-date-selector {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.flight-date-selector .date-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.flight-date-selector .nav-arrow {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flight-date-selector .nav-arrow:hover:not(.disabled) {
  background: #f5f5f5;
  border-color: #E31837;
  color: #E31837;
}

.flight-date-selector .nav-arrow.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.flight-date-selector .current-date {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background 0.2s;
}

.flight-date-selector .current-date:hover {
  background: #f5f5f5;
}

.flight-date-selector .date-text {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.flight-date-selector .calendar-icon {
  font-size: 20px;
}

.flight-date-selector .route-info {
  text-align: center;
  color: #666;
  margin-top: 8px;
  font-size: 14px;
}

/* Date Picker Modal */
.date-picker-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.date-picker-modal {
  background: white;
  border-radius: 16px;
  padding: 20px;
  width: 320px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.date-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.date-picker-header .month-nav {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  font-size: 12px;
}

.date-picker-header .month-year {
  font-size: 16px;
  font-weight: 600;
}

.date-picker-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  margin-bottom: 8px;
}

.date-picker-weekdays .weekday {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  padding: 8px 0;
}

.date-picker-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.date-picker-days .day-cell {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.date-picker-days .day-cell:not(.empty):not(.disabled):hover {
  background: #f0f0f0;
}

.date-picker-days .day-cell.selected {
  background: #E31837;
  color: white;
}

.date-picker-days .day-cell.disabled {
  color: #ccc;
  cursor: not-allowed;
}

.date-picker-footer {
  margin-top: 16px;
  text-align: right;
}

.date-picker-footer .cancel-btn {
  padding: 8px 16px;
  border: none;
  background: #f5f5f5;
  border-radius: 8px;
  cursor: pointer;
}

/* More Flights Button */
.more-flights-container {
  margin-top: 12px;
  text-align: center;
}

.more-flights-btn {
  padding: 12px 24px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
}

.more-flights-btn:hover {
  background: #f5f5f5;
  border-color: #E31837;
  color: #E31837;
}

.more-flights-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ================================================
   PAYMENT CARD INLINE STYLES
   ================================================ */

.payment-card-inline {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  max-width: 500px;
}

.payment-card-inline .payment-header {
  text-align: center;
  margin-bottom: 20px;
}

.payment-card-inline .secure-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.payment-card-inline .secure-icon {
  font-size: 14px;
}

.payment-card-inline .secure-text {
  font-size: 14px;
  font-weight: 600;
  color: #10B981;
}

.payment-card-inline .countdown-timer {
  font-size: 13px;
  color: #666;
}

.payment-card-inline .payment-price-section {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}

.payment-card-inline .total-price {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}

.payment-card-inline .payment-booking-summary {
  margin-top: 12px;
}

.payment-card-inline .booking-route {
  font-size: 14px;
  color: #666;
  margin: 4px 0;
}

.payment-card-inline .route-date {
  color: #999;
}

.payment-card-inline .payment-cards-section {
  padding: 20px 0;
}

.payment-card-inline .cards-loading {
  text-align: center;
  color: #666;
  padding: 20px;
}

.payment-card-inline .card-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.payment-card-inline .card-option:hover {
  border-color: #E31837;
}

.payment-card-inline .card-option.selected {
  border-color: #E31837;
  background: #FEF2F2;
}

.payment-card-inline .card-option input[type="radio"] {
  width: 20px;
  height: 20px;
  accent-color: #E31837;
}

.payment-card-inline .card-icon {
  font-size: 24px;
}

.payment-card-inline .card-name {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
}

.payment-card-inline .card-benefit {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
}

.payment-card-inline .card-benefit.cashback {
  background: #ECFDF5;
  color: #059669;
}

.payment-card-inline .add-icon {
  width: 24px;
  height: 24px;
  border: 2px dashed #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
}

.payment-card-inline .apple-icon {
  font-size: 24px;
}

.payment-card-inline .payment-actions {
  margin-top: 20px;
}

.payment-card-inline .pay-now-btn {
  width: 100%;
  padding: 16px;
  background: #E31837;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.payment-card-inline .pay-now-btn:hover:not(:disabled) {
  background: #C41230;
}

.payment-card-inline .pay-now-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.payment-card-inline .payment-expired {
  text-align: center;
  color: #DC2626;
  padding: 12px;
  background: #FEF2F2;
  border-radius: 8px;
  margin-top: 16px;
}

/* ================================================
   PASSENGER CONFIRMATION STYLES
   ================================================ */

.passenger-confirmation {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.passenger-confirmation .confirmation-header {
  background: #FEF3C7;
  padding: 16px;
  color: #92400E;
  font-size: 14px;
}

.passenger-confirmation .flight-summary-card {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.passenger-confirmation .lock-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #10B981;
  font-size: 13px;
  margin-bottom: 12px;
}

.passenger-confirmation .lock-icon {
  width: 20px;
  height: 20px;
  background: #10B981;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.passenger-confirmation .route-info {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.passenger-confirmation .dates-info {
  font-size: 13px;
  color: #666;
}

.passenger-confirmation .section {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.passenger-confirmation .section-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.passenger-confirmation .info-icon {
  font-size: 14px;
  cursor: help;
}

.passenger-confirmation .passenger-card,
.passenger-confirmation .contact-card {
  background: #F9FAFB;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}

.passenger-confirmation .passenger-header,
.passenger-confirmation .contact-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.passenger-confirmation .passenger-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.passenger-confirmation .name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.passenger-confirmation .membership-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  background: #DBEAFE;
  color: #1D4ED8;
  border-radius: 4px;
}

.passenger-confirmation .edit-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  border-radius: 50%;
  transition: background 0.2s;
}

.passenger-confirmation .edit-btn:hover {
  background: #E5E7EB;
}

.passenger-confirmation .passenger-details,
.passenger-confirmation .contact-details {
  font-size: 13px;
  color: #666;
}

.passenger-confirmation .detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
}

.passenger-confirmation .checkbox {
  width: 18px;
  height: 18px;
  background: #10B981;
  color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.passenger-confirmation .ff-text {
  color: #E31837;
  font-size: 13px;
}

.passenger-confirmation .add-more-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  border: none;
  background: transparent;
  color: #E31837;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.passenger-confirmation .add-more-btn:hover {
  background: #FEF2F2;
  border-radius: 8px;
}

.passenger-confirmation .plus-icon {
  width: 24px;
  height: 24px;
  border: 2px solid #E31837;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.passenger-confirmation .contact-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.passenger-confirmation .detail-text {
  font-size: 13px;
  color: #666;
  margin: 2px 0;
}

.passenger-confirmation .baggage-tip {
  font-size: 13px;
  color: #059669;
  margin-bottom: 12px;
}

.passenger-confirmation .baggage-card {
  background: #F9FAFB;
  border-radius: 12px;
  padding: 16px;
}

.passenger-confirmation .baggage-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.passenger-confirmation .baggage-icon {
  font-size: 24px;
}

.passenger-confirmation .baggage-details {
  flex: 1 1;
}

.passenger-confirmation .baggage-type {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.passenger-confirmation .baggage-info {
  font-size: 13px;
  color: #666;
}

.passenger-confirmation .add-baggage-btn {
  padding: 8px 16px;
  background: #10B981;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.passenger-confirmation .krisflyer-section {
  background: #FEF9E7;
}

.passenger-confirmation .krisflyer-benefits {
  padding: 0;
}

.passenger-confirmation .krisflyer-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.passenger-confirmation .krisflyer-icon {
  font-size: 20px;
}

.passenger-confirmation .krisflyer-title {
  font-size: 14px;
  font-weight: 600;
  color: #92400E;
}

.passenger-confirmation .benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.passenger-confirmation .benefit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  margin: 6px 0;
}

.passenger-confirmation .check-icon {
  color: #10B981;
}

.passenger-confirmation .price-section {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.passenger-confirmation .price-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}

.passenger-confirmation .total-price {
  font-size: 24px;
  font-weight: 700;
  color: #E31837;
}

.passenger-confirmation .confirmation-actions {
  padding: 20px;
}

.passenger-confirmation .continue-btn {
  width: 100%;
  padding: 16px;
  background: #E31837;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.passenger-confirmation .continue-btn:hover {
  background: #C41230;
}

/* KrisFlyer Badge on FlightCard */
.flight-card .krisflyer-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  background: linear-gradient(135deg, #FEF3C7, #FDE68A);
  color: #92400E;
  border-radius: 12px;
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;;EAExB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;;EAElB,oBAAoB;EACpB,uBAAuB;EACvB,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;;EAE3C,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;;EAEnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yCAAyC;;AAGzC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iHAAiH;EACjH,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E,0CAA0C;AAC1C;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,wCAAwC;AAC1C;;AAEA,uDAAuD;AACvD;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,gGAAgG;AAChG;;;;EAIE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;;IAEE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;IAGE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc,EAAE,sCAAsC;AACxD;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;EACvD,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;EAClB;;GAEC;IACC,cAAc;;EAEhB;GACC;IACC,cAAc;GACf;AACH;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,yCAAyC;EACzC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,sCAAsC;AACxC;;AAEA,cAAc;AACd;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,yCAAyC;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;;EAEE,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,wBAAwB;AACxB;;EAEE,kBAAkB;;AAEpB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA,cAAc;AACd;EACE,gBAAgB;;EAEhB,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;CACb,aAAa;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;AACd;;AAEA;;EAEE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,0DAA0D;EAC1D;IACE,cAAc;EAChB;;EAEA,2DAA2D;EAC3D;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA,wCAAwC;EACxC;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,yEAAyE;;AAEzE,4DAA4D;AAC5D;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,kCAAkC;EAClC,WAAW;EACX,oCAAoC;EACpC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;EAC/B,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;AAIA;AACA,8EAA8E;;AAE9E;;;EAGE,wBAAwB;EACxB;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,4BAA4B;IAC5B,kCAAkC;EACpC;;EAEA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,uBAAuB;EACvB;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,yCAAyC;IACzC,aAAa;IACb,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,6DAA6D;AAC7D;EACE;;;;;;;;;;GAUC;AACH;;AAEA,0CAA0C;AAC1C;EACE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAE9B,yBAAyB;EAC3B;AACF;;AAEA;;6CAE6C;AAC7C;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,4DAA4D;AAC9D;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,+BAA+B;EAC/B,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;;gDAEgD;;AAEhD;EACE,UAAU;;EAEV,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,6FAA6F;AAC/F;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,oCAAoC;EACpC,kDAAkD;EAClD,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;qDAEqD;;AAErD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;qDAEqD;;AAErD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;qDAEqD;;AAErD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* DBS Travel Companion - Global CSS Variables */\n:root {\n  /* DBS Brand Colors - Official DBS Red */\n  --dbs-red: #E31837;\n  --dbs-red-dark: #c41530;\n  --dbs-red-light: #f04058;\n\n  /* Text Colors */\n  --text-primary: #1a1a1a;\n  --text-secondary: #666666;\n  --text-muted: #999999;\n\n  /* Background Colors */\n  --bg-white: #ffffff;\n  --bg-light: #f5f7f9;\n  --bg-chat: #fafafa;\n\n  /* Border & Shadow */\n  --border-color: #e0e0e0;\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 25px rgba(0, 0, 0, 0.15);\n\n  /* Border Radius */\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 20px;\n  --radius-full: 50px;\n\n  /* Spacing */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n}\n\n/* Import Outfit font from Google Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  background: var(--bg-white);\n  background-attachment: fixed;\n  height: 100vh;\n  overflow: hidden;\n  color: var(--text-primary);\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n/* ==================== Chat Mode Layout (with AppShell) ==================== */\n\n/* Chat layout container inside AppShell */\n.chat-layout {\n  display: flex;\n  width: 100%;\n  height: calc(100vh - 120px);\n  /* Subtract two-row navbar height */\n  overflow: hidden;\n}\n\n.chat-area {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.chat-area.with-graph {\n  flex: 0 0 50%;\n  min-width: 400px;\n  max-width: 50%;\n}\n\n.graph-area {\n  flex: 0 0 50%;\n  min-width: 500px;\n  background: #1a1a1a;\n  border-left: 2px solid #404040;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.graph-area.fullscreen {\n  flex: 1;\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  border-left: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.App.chat-hidden .chat-layout {\n  justify-content: center;\n}\n\n/* Chat Content (message list + input) - no header */\n.chat-content {\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-white);\n  border-left: 1px solid var(--border-color);\n  border-right: 1px solid var(--border-color);\n}\n\n.chat-area.with-graph .chat-content {\n  max-width: 100%;\n  border-right: none;\n}\n\n/* Landing content area */\n.landing-content {\n  width: 100%;\n  padding-bottom: 3rem;\n}\n\n/* Legacy: Old main-layout for backward compatibility */\n.main-layout {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.chat-section {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.chat-section.with-graph {\n  flex: 0 0 50%;\n  min-width: 400px;\n  max-width: 50%;\n}\n\n.graph-section {\n  flex: 0 0 50%;\n  min-width: 500px;\n  height: 100vh;\n  background: #1a1a1a;\n  border-left: 2px solid #404040;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.graph-section.fullscreen-centered {\n  flex: 1;\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  border-left: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.App.chat-hidden .main-layout {\n  justify-content: center;\n}\n\n/* Legacy: Old Chat Container (kept for compatibility) */\n.chat-container {\n  max-width: 900px;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  background: var(--bg-white);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border-color);\n  box-shadow: none;\n}\n\n.chat-section.with-graph .chat-container {\n  max-width: 100%;\n  box-shadow: none;\n}\n\n/* Legacy: Old Chat Header (no longer used, kept for backward compatibility) */\n.chat-header {\n  background: var(--dbs-red);\n  color: white;\n  padding: 12px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: var(--shadow-md);\n  position: relative;\n}\n\n.chat-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.back-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.back-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.chat-header h1 {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.settings-btn,\n.reset-btn,\n.graph-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.settings-btn:hover,\n.reset-btn:hover,\n.graph-btn.active {\n  background: rgba(255, 255, 255, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n.graph-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* Chat Messages */\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: var(--bg-white);\n  /* Match landing page background */\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.message {\n  display: flex;\n  gap: 12px;\n}\n\n/* User messages: slide in from right */\n.message.user {\n  animation: slideInFromRight 0.3s ease-in;\n}\n\n/* Assistant messages: keep original fadeIn animation */\n.message.assistant {\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInFromRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Message layout - no avatar, just colored bubbles */\n.message {\n  display: flex;\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.message.user {\n  justify-content: flex-end;\n}\n\n.message.assistant {\n  justify-content: flex-start;\n}\n\n.message-content {\n  padding: 12px 16px;\n  border-radius: 18px;\n  line-height: 1.6;\n  word-wrap: break-word;\n  font-size: 14px;\n}\n\n/* User messages: right-aligned, max 75% width */\n.message.user .message-content {\n  max-width: 75%;\n}\n\n/* AI messages: left-aligned, full width (100%) */\n.message.assistant .message-content {\n  width: 100%;\n  max-width: 100%;\n}\n\n/* Ensure carousels and other components inside AI messages take full width of message-content */\n.message.assistant .message-content .a2ui-carousel,\n.message.assistant .message-content .destination-carousel,\n.message.assistant .message-content .a2ui-carousel-container,\n.message.assistant .message-content .destination-carousel-container {\n  width: 100%;\n  max-width: 100%;\n}\n\n.message.user .message-content {\n  background: var(--dbs-red);\n  /* DBS Red 品牌色 */\n  color: white;\n  border-bottom-right-radius: 4px;\n  border-top-left-radius: 18px;\n  border-top-right-radius: 18px;\n  border-bottom-left-radius: 18px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: var(--shadow-sm);\n}\n\n.message.assistant .message-content {\n  background: transparent;\n  color: var(--text-primary);\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 18px;\n  border-top-right-radius: 18px;\n  border-bottom-right-radius: 18px;\n  box-shadow: none;\n  /* Remove bubble effect */\n  border: none;\n  /* Remove border */\n  padding-left: 0;\n  /* Align text to the left edge */\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.message-content h1,\n.message-content h2,\n.message-content h3 {\n  margin-top: 12px;\n  margin-bottom: 8px;\n  color: inherit;\n}\n\n.message-content h1:first-child,\n.message-content h2:first-child,\n.message-content h3:first-child {\n  margin-top: 0;\n}\n\n.message-content p {\n  margin-bottom: 8px;\n}\n\n.message-content p:last-child {\n  margin-bottom: 0;\n}\n\n.message-content ul,\n.message-content ol {\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-bottom: 8px;\n}\n\n.message-content a {\n  color: inherit;\n  text-decoration: underline;\n  opacity: 0.9;\n}\n\n.message.user .message-content a {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.message-content code {\n  background: rgba(0, 0, 0, 0.1);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n}\n\n.message.user .message-content code {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.message-content pre {\n  background: rgba(0, 0, 0, 0.05);\n  padding: 12px;\n  border-radius: 8px;\n  overflow-x: auto;\n  margin-bottom: 8px;\n}\n\n.message.user .message-content pre {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.message-content pre code {\n  background: none;\n  padding: 0;\n}\n\n/* Agent States */\n.agent-states {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 8px;\n  padding: 0;\n}\n\n.agent-state {\n  font-size: 11px;\n  font-weight: 500;\n  color: #6b7280;\n  padding: 4px 8px;\n  background: rgba(255, 51, 51, 0.06);\n  border-radius: 4px;\n  border-left: 2px solid #F33;\n  animation: slideIn 0.3s ease-out;\n  line-height: 1.4;\n  font-family: 'Courier New', monospace;\n}\n\n.message.user .agent-state {\n  background: rgba(255, 255, 255, 0.08);\n  border-left-color: rgba(255, 255, 255, 0.4);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.agent-state-tool_call {\n  border-left-color: #3b82f6;\n  background: rgba(59, 130, 246, 0.06);\n}\n\n.message.user .agent-state-tool_call {\n  background: rgba(255, 255, 255, 0.08);\n  border-left-color: rgba(255, 255, 255, 0.4);\n}\n\n.agent-state-tool_response {\n  border-left-color: #10b981;\n  background: rgba(16, 185, 129, 0.06);\n}\n\n.message.user .agent-state-tool_response {\n  background: rgba(255, 255, 255, 0.08);\n  border-left-color: rgba(255, 255, 255, 0.4);\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05);\n  }\n}\n\n/* Typing Indicator */\n.typing-indicator {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 16px;\n}\n\n.typing-text {\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n}\n\n.message.user .typing-text {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.typing-dots {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.typing-dots span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #999;\n  animation: typing 1.4s infinite;\n}\n\n.message.user .typing-dots span {\n  background: rgba(255, 255, 255, 0.8);\n}\n\n.typing-dots span:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.typing-dots span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-dots span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing {\n\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.7;\n  }\n\n  30% {\n    transform: translateY(-10px);\n    opacity: 1;\n  }\n}\n\n/* Chat Input - New UI Style */\n.chat-input-container {\n  padding: 1rem 1.5rem 1.5rem 1.5rem;\n  background: var(--bg-white);\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-shrink: 0; /* Prevent input from being squashed */\n}\n\n.input-wrapper {\n  flex: 1;\n  position: relative;\n}\n\n.chat-input {\n  width: 100%;\n  padding: 14px 20px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-full);\n  font-size: 1rem;\n  font-family: inherit;\n  resize: none;\n  max-height: 120px;\n  min-height: 50px;\n  transition: all 0.2s;\n  background: var(--bg-light);\n}\n\n.chat-input:focus {\n  outline: none;\n  border-color: var(--dbs-red);\n  background: var(--bg-white);\n  box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.1);\n}\n\n.send-btn {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: var(--dbs-red);\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.send-btn:hover:not(:disabled) {\n  transform: scale(1.05);\n  background: var(--dbs-red-dark);\n  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);\n}\n\n.send-btn:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.send-btn i {\n  font-size: 1rem;\n}\n\n.send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Settings Panel */\n.settings-panel {\n  position: fixed;\n  top: 0;\n  right: -400px;\n  width: 400px;\n  height: 100vh;\n  background: white;\n  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n  transition: right 0.3s ease;\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.settings-panel.open {\n  right: 0;\n}\n\n.settings-header {\n  background: var(--dbs-red);\n  color: white;\n  padding: 12px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.settings-header h2 {\n  font-size: 18px;\n}\n\n.close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.settings-content {\n  padding: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #F33;\n}\n\n.form-group select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  background: white;\n}\n\n.form-group input.error,\n.form-group select.error {\n  border-color: #e74c3c;\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.user-type-description {\n  font-size: 12px;\n  color: #666;\n  padding: 8px 12px;\n  background: #f5f5f5;\n  border-radius: 6px;\n  margin-top: 4px;\n}\n\n/* Card Section */\n.card-section {\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-top: 8px;\n  margin-bottom: 20px;\n}\n\n.card-section-header {\n  background: #f9f9f9;\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.card-section-header:hover {\n  background: #f0f0f0;\n}\n\n.card-section-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.expand-icon {\n  font-size: 20px;\n  color: #666;\n  font-weight: 300;\n}\n\n.card-form {\n  padding: 20px;\n  background: white;\n}\n\n.div-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 16px;\n}\n\n.form-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n.form-row-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.settings-btn.save-btn {\n  background: var(--dbs-red) !important;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.settings-btn.save-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 51, 51, 0.4);\n}\n\n.settings-btn.save-btn:active {\n  transform: translateY(0);\n}\n\n.settings-btn.save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #999;\n}\n\n.empty-state-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n/* Credential Link */\n.credential-link {\n  display: inline-block;\n  margin-top: 12px;\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #F33 0%, #F33 100%);\n  color: white;\n  text-decoration: none;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: transform 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n}\n\n.credential-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n/* Payment Modal */\n.payment-modal {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 2000;\n  align-items: center;\n  justify-content: center;\n}\n\n.payment-modal.open {\n  display: flex;\n}\n\n/* Inline mode - renders as a card in the chat flow */\n.payment-modal.inline {\n  position: relative;\n  background: transparent;\n  width: 100%;\n  max-width: 500px;\n  height: auto;\n  z-index: 1;\n  animation: none;\n}\n\n.payment-modal.inline .payment-modal-content {\n  margin: 0;\n  width: 100%;\n  max-height: none;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.payment-modal.inline .payment-modal-close {\n  display: none;\n}\n\n/* Inline Payment Container - in chat flow */\n.inline-payment-container {\n  width: 100%;\n  max-width: 100%;\n  margin: 16px 0;\n  padding: 0;\n  animation: slideInUp 0.3s ease-out;\n}\n\n.inline-payment-container .payment-modal-content {\n  max-width: 100%;\n  width: 100%;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* New Payment Modal Design */\n.payment-modal-new {\n  padding: 0 !important;\n  border-radius: 12px;\n  overflow: hidden;\n  width: 100%;\n  max-width: 100%;\n}\n\n.payment-recommendation-banner {\n  background: #FFF5F5;\n  border-left: 4px solid #E53935;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #333;\n  line-height: 1.5;\n}\n\n.payment-secure-header {\n  text-align: center;\n  padding: 20px 16px 8px;\n}\n\n.secure-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: #E53935;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.shield-icon {\n  font-size: 16px;\n}\n\n.countdown-timer {\n  font-size: 13px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.payment-price-display {\n  text-align: center;\n  padding: 16px;\n}\n\n.price-amount {\n  font-size: 32px;\n  font-weight: 700;\n  color: #111;\n  margin-bottom: 8px;\n}\n\n.flight-routes,\n.booking-routes {\n  font-size: 13px;\n  color: #666;\n  line-height: 1.6;\n}\n\n.payment-card-list {\n  padding: 0 16px 16px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.payment-card-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border: 1px solid #E0E0E0;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.payment-card-option:hover {\n  border-color: #E53935;\n  background: #FFFAFA;\n}\n\n.payment-card-option.selected {\n  border-color: #E53935;\n  background: #FFFAFA;\n}\n\n.card-option-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.card-type-icon {\n  width: 32px;\n  height: auto;\n}\n\n.card-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.cashback-badge {\n  background: #E8F5E9;\n  color: #2E7D32;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 4px;\n}\n\n.add-icon {\n  font-size: 20px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #F5F5F5;\n  border-radius: 50%;\n  color: #666;\n  font-weight: 300;\n}\n\n.apple-pay-icon {\n  width: 24px;\n  height: 24px;\n  color: #000;\n}\n\n.card-radio {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #E53935;\n}\n\n.payment-btn-pay-now {\n  width: calc(100% - 32px);\n  margin: 0 16px 16px;\n  padding: 16px;\n  background: #E53935;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  box-sizing: border-box;\n}\n\n.inline-payment-container .payment-btn-pay-now {\n  width: calc(100% - 32px);\n}\n\n.payment-btn-pay-now:hover {\n  background: #C62828;\n}\n\n.payment-btn-pay-now:disabled {\n  background: #BDBDBD;\n  cursor: not-allowed;\n}\n\n/* Passenger Confirmation Loading */\n.passenger-confirmation .confirmation-loading {\n  padding: 40px;\n  text-align: center;\n  color: #666;\n}\n\n.payment-modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.payment-modal-header {\n  background: linear-gradient(135deg, #F33 0%, #F33 100%);\n  color: white;\n  padding: 20px 24px;\n  border-radius: 16px 16px 0 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.payment-modal-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.payment-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.payment-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.payment-card-container {\n  padding: 20px 24px;\n  background: #f5f5f5;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.payment-card {\n  background: #000000;\n  border-radius: 12px;\n  width: 250px;\n  height: 140px;\n  padding: 20px;\n  padding-top: 0px;\n  color: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.payment-card::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.payment-card-number {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 3px;\n  margin-bottom: 24px;\n  margin-top: 8px;\n  font-family: 'Courier New', monospace;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  z-index: 1;\n}\n\n.payment-card-number span {\n  display: inline-block;\n  margin: 0 2px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.payment-card-logo {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: auto;\n  position: relative;\n  z-index: 1;\n}\n\n.mastercard-logo {\n  width: 60px;\n  height: 38px;\n  background: #ffffff;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  padding: 4px;\n}\n\n.mastercard-circles {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mastercard-logo::before {\n  content: '';\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: #eb001b;\n  border-radius: 50%;\n  left: 8px;\n  z-index: 1;\n}\n\n.mastercard-logo::after {\n  content: '';\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: #f79e1b;\n  border-radius: 50%;\n  right: 8px;\n  z-index: 1;\n}\n\n.mastercard-text {\n  position: absolute;\n  bottom: 2px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 7px;\n  font-weight: bold;\n  color: #1a1a1a;\n  letter-spacing: 0.3px;\n  font-family: Arial, sans-serif;\n  z-index: 2;\n}\n\n.payment-modal-body {\n  padding: 24px;\n}\n\n.payment-info {\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.payment-info-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.payment-info-item:last-child {\n  border-bottom: none;\n}\n\n.payment-info-label {\n  font-weight: 600;\n  color: #666;\n}\n\n.payment-info-value {\n  color: #333;\n}\n\n.payment-form-group {\n  margin-bottom: 20px;\n}\n\n.payment-form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.payment-form-group input {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.payment-form-group input:focus {\n  outline: none;\n  border-color: #F33;\n}\n\n.payment-modal-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.payment-btn {\n  flex: 1;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.payment-btn-confirm {\n  background: linear-gradient(135deg, #F33 0%, #F33 100%);\n  color: white;\n}\n\n.payment-btn-confirm:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.payment-btn-cancel {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.payment-btn-cancel:hover:not(:disabled) {\n  background: #d0d0d0;\n}\n\n.payment-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Widget Blocks (list / carousel / cards) */\n.widget-blocks {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ui-block {\n  background: #fafafa;\n  border-radius: 12px;\n  padding: 12px 14px;\n  border: 1px solid #e5e5e5;\n}\n\n.message.user .ui-block {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.ui-block-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 8px;\n}\n\n.message.user .ui-block-title {\n  color: #fff;\n}\n\n/* List style */\n.ui-block-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ui-block-list-item {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.message.assistant .ui-block-list-item {\n  background: #fff;\n}\n\n.message.user .ui-block-list-item {\n  background: rgba(255, 255, 255, 0.06);\n  box-shadow: none;\n}\n\n.ui-block-item-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.ui-block-item-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.message.user .ui-block-item-title {\n  color: #ffffff;\n}\n\n.ui-block-item-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.message.user .ui-block-item-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.ui-block-item-meta {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.message.user .ui-block-item-meta {\n  color: #ffffff;\n}\n\n.ui-block-item-description {\n  font-size: 12px;\n  color: #4b5563;\n  margin-top: 2px;\n}\n\n.message.user .ui-block-item-description {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ui-block-item-tags,\n.ui-block-card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.ui-block-tag {\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.message.user .ui-block-tag {\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n}\n\n/* Carousel style */\n.ui-block-carousel {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  margin: 0 -4px;\n  padding-left: 4px;\n  scroll-snap-type: x mandatory;\n}\n\n.ui-block-carousel::-webkit-scrollbar {\n  height: 4px;\n}\n\n.ui-block-carousel::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.7);\n  border-radius: 999px;\n}\n\n.ui-block-card {\n  min-width: 190px;\n  max-width: 220px;\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  scroll-snap-align: start;\n}\n\n.message.user .ui-block-card {\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);\n}\n\n.ui-block-card-image-wrapper {\n  width: 100%;\n  height: 120px;\n  overflow: hidden;\n}\n\n.ui-block-card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.ui-block-card-body {\n  padding: 10px 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ui-block-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.message.user .ui-block-card-title {\n  color: #ffffff;\n}\n\n.ui-block-card-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.message.user .ui-block-card-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.ui-block-card-description {\n  font-size: 12px;\n  color: #4b5563;\n}\n\n.message.user .ui-block-card-description {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ui-block-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 4px;\n}\n\n.ui-block-card-price {\n  font-size: 13px;\n  font-weight: 700;\n  color: #16a34a;\n}\n\n.message.user .ui-block-card-price {\n  color: #4ade80;\n}\n\n.ui-block-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n@media (max-width: 768px) {\n  .ui-block-card {\n    min-width: 160px;\n  }\n\n   .a2ui-row-line-row {\n    display: block;\n   \n  }\n   .a2ui-list-item {\n    display: block;\n   }\n}\n\n/* A2UI Components Styles */\n.a2ui-renderer {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Animation for newly added components */\n.component-newly-added {\n  animation: componentSlideIn 0.4s ease-out;\n  opacity: 0;\n  animation-fill-mode: forwards;\n}\n\n@keyframes componentSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Stagger animation for multiple components */\n.a2ui-renderer>*:nth-child(1).component-newly-added {\n  animation-delay: 0s;\n}\n\n.a2ui-renderer>*:nth-child(2).component-newly-added {\n  animation-delay: 0.05s;\n}\n\n.a2ui-renderer>*:nth-child(3).component-newly-added {\n  animation-delay: 0.1s;\n}\n\n.a2ui-renderer>*:nth-child(4).component-newly-added {\n  animation-delay: 0.15s;\n}\n\n.a2ui-renderer>*:nth-child(n+5).component-newly-added {\n  animation-delay: 0.2s;\n}\n\n/* A2UI Text */\n.a2ui-text {\n  font-size: 14px;\n  color: inherit;\n  line-height: 1.5;\n}\n\n/* A2UI Button */\n.a2ui-button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: inline-block;\n}\n\n.a2ui-button-primary {\n  background: var(--dbs-red);\n  color: white;\n  border: 1px solid var(--dbs-red);\n  font-weight: 500;\n}\n\n.a2ui-button-primary:hover {\n  background: var(--dbs-red-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);\n}\n\n.a2ui-button-secondary {\n  background: var(--bg-light);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  font-weight: 500;\n}\n\n.a2ui-button-secondary:hover {\n  background: var(--bg-white);\n  border-color: var(--dbs-red);\n  color: var(--dbs-red);\n}\n\n.a2ui-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.message.user .a2ui-button-primary {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.message.user .a2ui-button-primary:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.message.user .a2ui-button-secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n/* A2UI List */\n.a2ui-list {\n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  padding: 12px 14px;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.message.user .a2ui-list {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.a2ui-list-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 8px;\n}\n\n.message.user .a2ui-list-title {\n  color: #fff;\n}\n\n.a2ui-list-items {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.a2ui-list-item {\n  background: var(--bg-white);\n  border-radius: var(--radius-sm);\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.2s;\n  border: 1px solid var(--border-color);\n}\n\n/* List item with image - horizontal layout */\n.a2ui-list-item.a2ui-list-item-with-image {\n  flex-direction: row;\n  gap: 12px;\n  padding: 12px;\n}\n\n.a2ui-list-item-image-wrapper {\n  flex-shrink: 0;\n  width: 60px;\n  height: 60px;\n  align-self: center; /* vertical center within list item row */\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.a2ui-list-item-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.a2ui-list-item-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  /* Allow text truncation */\n}\n\n.a2ui-list-item.a2ui-clickable {\n  cursor: pointer;\n}\n\n.a2ui-list-item.a2ui-clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--dbs-red);\n}\n\n.message.assistant .a2ui-list-item {\n  background: #fff;\n}\n\n.message.user .a2ui-list-item {\n  background: rgba(255, 255, 255, 0.06);\n  box-shadow: none;\n}\n\n.message.user .a2ui-list-item.a2ui-clickable:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.message.user .a2ui-list-item-image-wrapper {\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.a2ui-list-item-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.a2ui-row-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background: #f8f8f8;\n  border-radius: 5px;\n  padding: 4px 8px;\n}\n\n.a2ui-row-line-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: center;\n  column-gap: 12px;\n  min-width: 0;\n}\n\n.a2ui-row-cell {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.a2ui-row-cell-left {\n  justify-self: start;\n}\n\n.a2ui-row-cell-middle {\n  justify-self: center;\n  text-align: center;\n  padding: 0 6px;\n  color: var(--text-secondary);\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.a2ui-row-cell-right {\n  justify-self: end;\n  text-align: right;\n}\n\n.a2ui-row-line-1 .a2ui-row-cell {\n  font-size: 12px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.a2ui-row-line-2 .a2ui-row-cell {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-weight: 400;\n}\n\n.message.user .a2ui-row-line-1 .a2ui-row-cell {\n  color: #ffffff;\n}\n\n.message.user .a2ui-row-line-2 .a2ui-row-cell {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.message.user .a2ui-row-cell-middle {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.a2ui-link-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(227, 24, 55, 0.35);\n  color: var(--dbs-red);\n  background: rgba(227, 24, 55, 0.06);\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  user-select: none;\n}\n\n.a2ui-link-btn:hover {\n  background: rgba(227, 24, 55, 0.12);\n  border-color: rgba(227, 24, 55, 0.55);\n}\n\n.message.user .a2ui-link-btn {\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.35);\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.message.user .a2ui-link-btn:hover {\n  background: rgba(255, 255, 255, 0.18);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.a2ui-list-item-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.message.user .a2ui-list-item-title {\n  color: #ffffff;\n}\n\n.a2ui-list-item-subtitle {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.message.user .a2ui-list-item-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.a2ui-list-item-meta {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n  /* Vertically center meta content (e.g., link/price/button) */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n}\n\n.message.user .a2ui-list-item-meta {\n  color: #ffffff;\n}\n\n.a2ui-list-item-description {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-top: 2px;\n}\n\n.message.user .a2ui-list-item-description {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.a2ui-list-item-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.a2ui-tag {\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.message.user .a2ui-tag {\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n}\n\n.a2ui-list-item-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.a2ui-list-item-action-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n/* Smart Mapping: Enhanced styles for flight/hotel content */\n.a2ui-list-flight-enhanced .a2ui-list-item,\n.a2ui-card-flight-enhanced .a2ui-card {\n  border-left: 3px solid var(--dbs-red);\n  padding-left: 11px;\n  /* Adjust for border */\n}\n\n.a2ui-list-hotel-enhanced .a2ui-list-item,\n.a2ui-card-hotel-enhanced .a2ui-card {\n  border-left: 3px solid #4caf50;\n  padding-left: 11px;\n  /* Adjust for border */\n}\n\n.a2ui-list-flight-enhanced .a2ui-list-item-title,\n.a2ui-card-flight-enhanced .a2ui-card-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.a2ui-list-flight-enhanced .a2ui-list-item-title::before {\n  content: '✈️';\n  font-size: 1rem;\n}\n\n.a2ui-list-hotel-enhanced .a2ui-list-item-title,\n.a2ui-card-hotel-enhanced .a2ui-card-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.a2ui-list-hotel-enhanced .a2ui-list-item-title::before {\n  content: '🏨';\n  font-size: 1rem;\n}\n\n/* A2UI Card Container */\n.a2ui-card-container {\n \n  padding: 12px 14px;\n \n}\n\n.message.user .a2ui-card-container {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.a2ui-card-container>.a2ui-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 12px;\n}\n\n.message.user .a2ui-card-container>.a2ui-card-title {\n  color: #fff;\n}\n\n.a2ui-card-items {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n/* A2UI Card */\n.a2ui-card {\n  min-width: 190px;\n \n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  display: flex;\n  transition: all 0.2s;\n  border: 1px solid var(--border-color);\n}\n\n.a2ui-card.a2ui-card-full-width {\n  width: 100%;\n  flex-basis: 100%;\n}\n\n.a2ui-card.a2ui-clickable {\n  cursor: pointer;\n}\n\n.a2ui-card.a2ui-clickable:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n  border-color: var(--dbs-red);\n}\n\n.message.user .a2ui-card {\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);\n}\n\n.message.user .a2ui-card.a2ui-clickable:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.a2ui-card-image-wrapper {\n  width: 140px;\n height: 140px;\n  overflow: hidden;\n  padding: 12px;\n}\n\n.a2ui-card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  border-radius: 10px;\n}\n\n.a2ui-card-body {\n  width: 90%;\n  padding: 10px 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.a2ui-card-body.a2ui-card-body-fullwidth {\n  width: 100%;\n}\n\n.a2ui-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: 0 5px;\n}\n\n.message.user .a2ui-card-title {\n  color: #ffffff;\n}\n\n.a2ui-card-subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  padding: 0 5px;\n}\n\n.message.user .a2ui-card-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.a2ui-card-description {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.message.user .a2ui-card-description {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.a2ui-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 4px;\n}\n\n.a2ui-card-price {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--dbs-red);\n  /* 使用 DBS Red 作为价格颜色 */\n  margin-left: auto;\n  text-align: right;\n}\n\n.message.user .a2ui-card-price {\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.a2ui-card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.a2ui-card-action-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n/* A2UI Carousel */\n.a2ui-carousel {\n  background: #fafafa;\n  border-radius: 12px;\n  padding: 12px 14px;\n  border: 1px solid #e5e5e5;\n}\n\n.message.user .a2ui-carousel {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.a2ui-carousel-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 12px;\n}\n\n.message.user .a2ui-carousel-title {\n  color: #fff;\n}\n\n.a2ui-carousel-container {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  margin: 0 -4px;\n  padding-left: 4px;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n}\n\n.a2ui-carousel-container::-webkit-scrollbar {\n  height: 4px;\n}\n\n.a2ui-carousel-container::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.7);\n  border-radius: 999px;\n}\n\n.a2ui-carousel-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.a2ui-carousel-card {\n  scroll-snap-align: start;\n  flex-shrink: 0;\n}\n\n/* A2UI Form */\n.a2ui-form {\n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.message.user .a2ui-form {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.a2ui-form-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 12px;\n}\n\n.message.user .a2ui-form-title {\n  color: #fff;\n}\n\n.a2ui-form-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.a2ui-input-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.a2ui-input-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.message.user .a2ui-input-label {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.a2ui-input,\n.a2ui-select {\n  padding: 10px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  background: var(--bg-white);\n  color: var(--text-primary);\n  transition: all 0.2s;\n  font-family: 'Outfit', inherit;\n}\n\n.a2ui-input:focus,\n.a2ui-select:focus {\n  outline: none;\n  border-color: var(--dbs-red);\n  box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.1);\n}\n\n.message.user .a2ui-input,\n.message.user .a2ui-select {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.message.user .a2ui-input:focus,\n.message.user .a2ui-select:focus {\n  border-color: rgba(255, 255, 255, 0.4);\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);\n}\n\n.a2ui-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.a2ui-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #374151;\n}\n\n.message.user .a2ui-checkbox-label {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.a2ui-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--dbs-red);\n}\n\n.a2ui-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* A2UI Container */\n.a2ui-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .chat-container {\n    height: 100%;\n    max-width: 100%;\n  }\n\n  /* User messages: right-aligned, max 85% width on mobile */\n  .message.user .message-content {\n    max-width: 85%;\n  }\n\n  /* AI messages: left-aligned, full width (100%) on mobile */\n  .message.assistant .message-content {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .settings-panel {\n    width: 100%;\n    right: -100%;\n  }\n\n  .a2ui-card,\n  .a2ui-carousel-card {\n    min-width: 160px;\n  }\n\n  /* Optimize list item image for mobile */\n  .a2ui-list-item-image-wrapper {\n    width: 70px;\n    height: 70px;\n  }\n\n  .a2ui-list-item.a2ui-list-item-with-image {\n    gap: 10px;\n    padding: 10px;\n    display: block;\n  }\n}\n\n/* ==================== Travel-Specific Components ==================== */\n\n/* Flight Card - Compact layout for 5-6 options per screen */\n.flight-card {\n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  padding: 0.625rem 0.75rem;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.flight-card:hover {\n  border-color: var(--dbs-red);\n  box-shadow: var(--shadow-sm);\n}\n\n.flight-card.selected {\n  border-color: var(--dbs-red);\n  background: rgba(255, 0, 0, 0.02);\n}\n\n.flight-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.375rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.flight-airline {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n}\n\n.airline-logo {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.airline-name {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n.flight-number {\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n}\n\n.flight-price {\n  text-align: right;\n  display: flex;\n  align-items: baseline;\n  gap: 0.125rem;\n}\n\n.flight-price .price-currency {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.flight-price .price-amount {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--dbs-red);\n}\n\n.flight-price .price-per {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.flight-card-body {\n  padding: 0.25rem 0;\n}\n\n.flight-route {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.route-point {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.route-point.departure {\n  text-align: left;\n}\n\n.route-point.arrival {\n  text-align: right;\n}\n\n.route-time {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.route-code {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.route-city {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.route-line {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.125rem;\n}\n\n.route-duration {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.route-visual {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.route-visual .dot {\n  width: 6px;\n  height: 6px;\n  background: var(--dbs-red);\n  border-radius: 50%;\n}\n\n.route-visual .line {\n  flex: 1;\n  height: 1px;\n  background: var(--border-color);\n}\n\n.route-visual .stop-indicator {\n  padding: 0 0.375rem;\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.route-stops {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.route-stops.nonstop {\n  color: #4caf50;\n  font-weight: 500;\n}\n\n/* Hide flight details by default to save space - shown inline in header */\n.flight-details {\n  display: none;\n}\n\n.flight-details .cabin-class,\n.flight-details .aircraft {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  background: var(--bg-light);\n  padding: 0.125rem 0.375rem;\n  border-radius: var(--radius-sm);\n}\n\n.flight-card-footer {\n  margin-top: 0.5rem;\n  padding-top: 0.375rem;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.flight-card-footer .a2ui-button {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n/* Hotel List Item */\n.hotel-list-item {\n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  display: flex;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 0.5rem;\n}\n\n.hotel-list-item:hover {\n  border-color: var(--dbs-red);\n  box-shadow: var(--shadow-md);\n}\n\n.hotel-list-item.selected {\n  border-color: var(--dbs-red);\n  background: rgba(255, 0, 0, 0.02);\n}\n\n.hotel-image-wrapper {\n  width: 140px;\n  height: 140px;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.hotel-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n}\n\n.hotel-discount-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: var(--dbs-red);\n  color: white;\n  padding: 0.25rem 0.5rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.hotel-content {\n  flex: 1;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.hotel-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.hotel-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.hotel-name {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 0.125rem 0;\n}\n\n.hotel-stars {\n  display: flex;\n  gap: 2px;\n  color: #ffc107;\n  font-size: 0.75rem;\n}\n\n.hotel-rating {\n  background: #4caf50;\n  color: white;\n  padding: 0.15rem 0.4rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.hotel-location {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.hotel-location i {\n  margin-right: 0.25rem;\n}\n\n.hotel-description {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.hotel-amenities {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.amenity-tag {\n  background: var(--bg-light);\n  color: var(--text-secondary);\n  padding: 0.2rem 0.5rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n}\n\n.amenity-more {\n  color: var(--text-muted);\n  font-size: 0.75rem;\n}\n\n.hotel-room-type {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.hotel-price-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: space-between;\n  padding: 1rem;\n  min-width: 140px;\n  border-left: 1px solid var(--border-color);\n}\n\n.hotel-price {\n  text-align: right;\n}\n\n.hotel-price .original-price {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  text-decoration: line-through;\n  display: block;\n}\n\n.hotel-price .current-price {\n  color: var(--dbs-red);\n}\n\n.hotel-price .price-amount {\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n.hotel-price .price-per {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n/* Destination Carousel - 匹配新UI设计 */\n.destination-carousel {\n  padding: 0.5rem 0.2rem 1rem 0.2rem;\n  width: 100%;\n  /* Hide scrollbar for cleaner look */\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.destination-carousel::-webkit-scrollbar {\n  display: none;\n}\n\n.carousel-mid-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 1rem 0 0.5rem 0.2rem;\n  color: var(--text-primary);\n}\n\n.destination-carousel-container {\n  display: flex;\n  gap: 1rem;\n  overflow-x: auto;\n  padding: 0.5rem 0.2rem 1rem 0.2rem;\n  width: 100%;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n}\n\n.destination-carousel-container::-webkit-scrollbar {\n  display: none;\n}\n\n.carousel-card {\n  min-width: 200px;\n  width: 200px;\n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  flex-shrink: 0;\n  cursor: pointer;\n  border: 1px solid #eee;\n  transition: transform 0.2s, box-shadow 0.2s;\n  position: relative;\n}\n\n.carousel-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n}\n\n.carousel-image {\n  height: 120px;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n}\n\n/* Gradient overlay for text readability */\n.carousel-image::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 60%;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);\n}\n\n.carousel-city-name {\n  position: absolute;\n  bottom: 10px;\n  left: 12px;\n  color: white;\n  font-weight: 700;\n  font-size: 1.1rem;\n  z-index: 2;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.deal-badge {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  background: #e6f4ea;\n  color: #137333;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n  z-index: 2;\n}\n\n.typical-badge {\n  background: #f1f3f4;\n  color: #5f6368;\n}\n\n.carousel-content {\n  padding: 0.8rem;\n}\n\n.carousel-food {\n  font-size: 0.8rem;\n  color: #444;\n  margin-bottom: 0.3rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.carousel-food i {\n  color: #aa1f1f;\n  font-size: 0.7rem;\n}\n\n.carousel-dates {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.carousel-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.carousel-from {\n  font-size: 0.7rem;\n  color: #888;\n}\n\n.carousel-price {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--dbs-red);\n}\n\n/* Suggestion Chips */\n.suggestion-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.5rem 0;\n}\n\n.suggestion-chip {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--bg-white);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.suggestion-chip:hover {\n  border-color: var(--dbs-red);\n  background: rgba(255, 0, 0, 0.02);\n}\n\n.suggestion-chip i {\n  color: var(--dbs-red);\n  font-size: 0.85rem;\n}\n\n/* Itinerary Card */\n.itinerary-card {\n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  padding: 1.25rem;\n  margin-bottom: 0.75rem;\n}\n\n.itinerary-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.itinerary-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.itinerary-status {\n  padding: 0.25rem 0.75rem;\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.itinerary-status.confirmed {\n  background: #e8f5e9;\n  color: #4caf50;\n}\n\n.itinerary-status.pending {\n  background: #fff3e0;\n  color: #ff9800;\n}\n\n.itinerary-status.cancelled {\n  background: #ffebee;\n  color: #f44336;\n}\n\n.itinerary-dates {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  margin-bottom: 1rem;\n}\n\n.confirmation-number {\n  display: flex;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n  background: var(--bg-light);\n  border-radius: var(--radius-sm);\n}\n\n.confirmation-number .label {\n  color: var(--text-secondary);\n}\n\n.confirmation-number .value {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-family: monospace;\n}\n\n.itinerary-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1rem 0;\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.itinerary-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.itinerary-item i {\n  width: 24px;\n  color: var(--dbs-red);\n}\n\n.itinerary-item .item-content {\n  flex: 1;\n}\n\n.itinerary-item .item-title {\n  font-weight: 600;\n  color: var(--text-primary);\n  display: block;\n}\n\n.itinerary-item .item-subtitle {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.itinerary-item .item-price {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.itinerary-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n}\n\n.itinerary-footer .total-price {\n  display: flex;\n  flex-direction: column;\n}\n\n.itinerary-footer .total-price .label {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.itinerary-footer .total-price .value {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--dbs-red);\n}\n\n.itinerary-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* Landing mode specific */\n.App.landing-mode {\n  background: var(--bg-white);\n  overflow-y: auto;\n}\n\n@media (max-width: 590) {\n\n \n\n}\n/* ==================== Mobile Responsive Optimizations ==================== */\n\n@media (max-width: 480px) {\n\n\n  /* Landing View Mobile */\n  .landing-navbar {\n    padding: 0.75rem 4%;\n  }\n\n  .nav-logo {\n    height: 40px;\n  }\n\n  .hero-title {\n    font-size: 1.6rem;\n    line-height: 1.3;\n  }\n\n  .hero-subtitle {\n    font-size: 0.95rem;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .departure-options {\n    min-width: 280px;\n    left: 50%;\n    transform: translateX(-50%) translateY(10px);\n  }\n\n  .search-input {\n    padding: 1rem;\n    font-size: 1rem;\n  }\n\n  .trip-filters {\n    gap: 0.5rem;\n    padding: 0 0.5rem;\n  }\n\n  .filter-group {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.8rem;\n  }\n\n  .filter-popup {\n    position: fixed;\n    top: auto;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    border-radius: 20px 20px 0 0;\n    animation: slideUpMobile 0.3s ease;\n  }\n\n  @keyframes slideUpMobile {\n    from {\n      transform: translateY(100%);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  .cards-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .travel-card {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .card-image-wrapper {\n    width: 100%;\n    height: 160px;\n  }\n\n  .pricing-row {\n    flex-direction: column;\n    gap: 0.75rem;\n    align-items: flex-start;\n  }\n\n  /* Chat View Mobile */\n  .chat-header {\n    padding: 10px 12px;\n  }\n\n  .chat-header h1 {\n    font-size: 16px;\n  }\n\n  .back-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .chat-input-container {\n    padding: 10px 12px;\n  }\n\n  .chat-input {\n    padding: 10px 12px;\n    font-size: 14px;\n  }\n\n  .send-btn {\n    width: 40px;\n    height: 40px;\n  }\n\n  /* Flight Card Mobile */\n  .flight-card {\n    padding: 0.5rem;\n  }\n\n  .flight-route {\n    flex-direction: row;\n    gap: 0.5rem;\n  }\n\n  .route-point {\n    text-align: left;\n  }\n\n  .route-point.arrival {\n    text-align: right;\n  }\n\n  .route-line {\n    flex: 1;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .route-visual {\n    width: 100%;\n    min-width: 100px;\n  }\n\n  /* Hotel List Item Mobile */\n  .hotel-list-item {\n    flex-direction: column;\n  }\n\n  .hotel-image-wrapper {\n    width: 100%;\n    height: 180px;\n  }\n\n  .hotel-price-section {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    border-left: none;\n    border-top: 1px solid var(--border-color);\n    padding: 1rem;\n    min-width: auto;\n  }\n\n  /* Destination Carousel Mobile */\n  .destination-card {\n    min-width: 200px;\n  }\n\n  /* Suggestion Chips Mobile */\n  .suggestion-chips {\n    gap: 0.5rem;\n  }\n\n  .suggestion-chip {\n    padding: 0.4rem 0.75rem;\n    font-size: 0.85rem;\n  }\n}\n\n/* Tablet Optimizations */\n@media (min-width: 481px) and (max-width: 1024px) {\n  .landing-main {\n    padding: 0 4%;\n  }\n\n  .cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .flight-route {\n    gap: 0.75rem;\n  }\n}\n\n/* High Resolution / Large Screen */\n@media (min-width: 1440px) {\n  .landing-main {\n    max-width: 1600px;\n  }\n\n  .hero-title {\n    font-size: 3.2rem;\n  }\n\n  .search-container {\n    max-width: 750px;\n  }\n\n  .cards-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Dark Mode Support (optional - follows system preference) */\n@media (prefers-color-scheme: dark) {\n  /* Uncomment to enable dark mode\n  :root {\n    --text-primary: #f5f5f5;\n    --text-secondary: #b0b0b0;\n    --text-muted: #808080;\n    --bg-white: #1a1a1a;\n    --bg-light: #2a2a2a;\n    --bg-chat: #242424;\n    --border-color: #404040;\n  }\n  */\n}\n\n/* Print Styles for Booking Confirmation */\n@media print {\n  .booking-confirmation {\n    box-shadow: none;\n    border: 1px solid #ddd;\n  }\n\n  .confirmation-actions,\n  .return-home {\n    display: none;\n  }\n\n  .confirmation-header {\n    background: #4caf50 !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n}\n\n/* ========================================\n   Flight Booking Summary Component\n   ======================================== */\n.flight-booking-summary {\n  background: var(--bg-white);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.flight-booking-summary .summary-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1rem;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-light);\n}\n\n.flight-booking-summary .header-icon {\n  font-size: 1rem;\n}\n\n.flight-booking-summary .header-title {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: var(--text-primary);\n}\n\n/* Flight Leg */\n.flight-booking-summary .flight-leg {\n  padding: 1rem;\n}\n\n.flight-booking-summary .flight-leg-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.flight-booking-summary .airline-logo-summary {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.flight-booking-summary .flight-number-summary {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--text-secondary, #666);\n}\n\n.flight-booking-summary .flight-meta {\n  margin-left: auto;\n  font-size: 0.75rem;\n  color: var(--text-secondary, #666);\n}\n\n.flight-booking-summary .airline-tag {\n  background: linear-gradient(135deg, #f5e6a3 0%, #d4af37 100%);\n  color: #5c4b00;\n  padding: 0.25rem 0.625rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.flight-booking-summary .flight-meta {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n/* Flight Times */\n.flight-booking-summary .flight-times {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.flight-booking-summary .time-point {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.flight-booking-summary .time-point.departure {\n  text-align: left;\n  min-width: 60px;\n}\n\n.flight-booking-summary .time-point.arrival {\n  text-align: right;\n  min-width: 60px;\n}\n\n.flight-booking-summary .time-point .time {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.flight-booking-summary .time-point .time sup {\n  font-size: 0.7rem;\n  color: var(--dbs-red);\n  font-weight: 600;\n  margin-left: 2px;\n}\n\n.flight-booking-summary .time-point .airport {\n  font-size: 0.8rem;\n  color: #5db8a3;\n  font-weight: 500;\n}\n\n.flight-booking-summary .time-line {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n}\n\n.flight-booking-summary .time-line .line {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(90deg, #d4af37 0%, #d4af37 100%);\n}\n\n/* Leg Divider */\n.flight-booking-summary .leg-divider {\n  height: 1px;\n  background: var(--border-color);\n  margin: 0;\n}\n\n/* Total Price Row */\n.flight-booking-summary .total-price-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.875rem 1rem;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-light);\n}\n\n.flight-booking-summary .total-label {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n}\n\n.flight-booking-summary .total-amount {\n  font-weight: 700;\n  font-size: 1.1rem;\n  color: var(--text-primary);\n}\n\n/* Action Buttons */\n.flight-booking-summary .summary-actions {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.flight-booking-summary .btn-confirm-pay {\n  flex: 2;\n  padding: 0.75rem 1rem;\n  background: var(--dbs-red);\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.flight-booking-summary .btn-confirm-pay:hover {\n  background: var(--dbs-red-dark);\n  transform: translateY(-1px);\n}\n\n.flight-booking-summary .btn-edit {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  background: var(--bg-white);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.flight-booking-summary .btn-edit:hover {\n  background: var(--bg-light);\n  border-color: var(--text-secondary);\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .flight-booking-summary .time-point .time {\n    font-size: 1.25rem;\n  }\n\n  .flight-booking-summary .summary-actions {\n    flex-direction: column;\n  }\n\n  .flight-booking-summary .btn-confirm-pay,\n  .flight-booking-summary .btn-edit {\n    flex: none;\n    width: 100%;\n  }\n}\n\n/* ===========================================\n   FlightReceipt Component - Compact Design (max 60% viewport)\n   =========================================== */\n\n.flight-receipt {\n  width: 90%;\n\n  max-height: 65vh;\n  margin: 0.75rem auto;\n  background: var(--bg-white, #fff);\n  border-radius: var(--radius-lg, 12px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  overflow-y: auto;\n}\n\n.flight-receipt .receipt-header {\n  background: linear-gradient(135deg, #E53935 0%, #C62828 100%);\n  color: white;\n  padding: 1rem 1.25rem;\n  text-align: center;\n}\n\n.flight-receipt .success-icon {\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.5rem;\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n.flight-receipt .receipt-title {\n  margin: 0 0 0.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.flight-receipt .receipt-subtitle {\n  margin: 0;\n  font-size: 0.8rem;\n  opacity: 0.9;\n}\n\n.flight-receipt .receipt-reference {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-bottom: 1px solid var(--border-color, #e5e7eb);\n}\n\n.flight-receipt .reference-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.flight-receipt .reference-item .label {\n  font-size: 0.65rem;\n  color: var(--text-secondary, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.flight-receipt .reference-item .value {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n\n.flight-receipt .reference-code {\n  font-family: monospace;\n  font-size: 1rem;\n  letter-spacing: 0.15em;\n  color: var(--dbs-red, #e31837);\n}\n\n.flight-receipt .status-badge {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.flight-receipt .status-badge.confirmed {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.flight-receipt .status-badge.pending {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n/* Compact Flight Legs */\n.flight-receipt .receipt-flights {\n  padding: 0.75rem 1rem;\n}\n\n.flight-receipt .receipt-flight-leg {\n  padding: 0.5rem 0;\n  border-bottom: 1px dashed var(--border-color, #e5e7eb);\n}\n\n.flight-receipt .receipt-flight-leg:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.flight-receipt .leg-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.flight-receipt .leg-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--text-secondary, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.flight-receipt .leg-flight-info {\n  font-size: 0.75rem;\n  color: var(--text-secondary, #6b7280);\n}\n\n.flight-receipt .leg-route-compact {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.flight-receipt .route-point {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.flight-receipt .route-point .time {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary, #111827);\n}\n\n.flight-receipt .route-point .time .next-day {\n  font-size: 0.55rem;\n  color: var(--dbs-red, #e31837);\n  vertical-align: super;\n  margin-left: 2px;\n}\n\n.flight-receipt .route-point .code {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-secondary, #6b7280);\n}\n\n.flight-receipt .route-arrow-compact {\n  font-size: 1rem;\n  color: var(--text-muted, #9ca3af);\n  padding: 0 0.5rem;\n}\n\n.flight-receipt .duration-compact {\n  font-size: 0.7rem;\n  color: var(--text-muted, #9ca3af);\n  margin-left: auto;\n  background: linear-gradient(to right, transparent, var(--border-color, #e5e7eb), transparent);\n}\n\n.flight-receipt .route-arrow .arrow-head {\n  font-size: 1.25rem;\n}\n\n.flight-receipt .leg-meta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.flight-receipt .meta-item {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #6b7280);\n}\n\n.flight-receipt .meta-divider {\n  color: var(--text-muted, #9ca3af);\n  font-size: 0.6rem;\n}\n\n.flight-receipt .receipt-passenger {\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background: var(--bg-light, #f8f9fa);\n  border-top: 1px solid var(--border-color, #e5e7eb);\n  border-bottom: 1px solid var(--border-color, #e5e7eb);\n}\n\n.flight-receipt .receipt-passenger .label {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #6b7280);\n}\n\n.flight-receipt .receipt-passenger .value {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n\n/* Compact Payment Summary */\n.flight-receipt .receipt-payment {\n  padding: 0.75rem 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-top: 1px solid var(--border-color, #e5e7eb);\n}\n\n.flight-receipt .payment-row.total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n  margin-bottom: 0.5rem;\n}\n\n.flight-receipt .payment-row.total .total-amount {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--dbs-red, #e31837);\n}\n\n.flight-receipt .payment-card-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8rem;\n}\n\n.flight-receipt .payment-card-row .card-info {\n  color: var(--text-secondary, #6b7280);\n}\n\n.flight-receipt .payment-card-row .card-benefit {\n  background: #dbeafe;\n  color: #1d4ed8;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 0.7rem;\n}\n\n/* Hotel Receipt Styles */\n.hotel-receipt .receipt-header {\n  text-align: center;\n  padding: 1.5rem 1rem 1rem 1rem;\n  background: linear-gradient(135deg, #E53935 0%, #C62828 100%);\n  color: white;\n}\n\n.hotel-receipt .success-icon {\n  width: 48px;\n  height: 48px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 0.75rem auto;\n  font-size: 1.5rem;\n}\n\n.hotel-receipt .receipt-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  margin: 0 0 0.25rem 0;\n}\n\n.hotel-receipt .receipt-subtitle {\n  font-size: 0.9rem;\n  opacity: 0.9;\n  margin: 0;\n}\n\n.hotel-receipt .hotel-image-section {\n  width: 100%;\n  height: 120px;\n  overflow: hidden;\n  position: relative;\n}\n\n.hotel-receipt .receipt-reference {\n  padding: 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-bottom: 1px solid var(--border-color, #e5e7eb);\n}\n\n.hotel-receipt .reference-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.hotel-receipt .reference-label {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #6b7280);\n  font-weight: 500;\n}\n\n.hotel-receipt .reference-value {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary, #111827);\n  font-family: 'Courier New', monospace;\n  letter-spacing: 1px;\n}\n\n.hotel-receipt .receipt-body {\n  padding: 1rem;\n}\n\n.hotel-receipt .hotel-details-section {\n  margin-bottom: 1.5rem;\n}\n\n.hotel-receipt .section-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary, #111827);\n  margin: 0 0 0.75rem 0;\n  display: flex;\n  align-items: center;\n}\n\n.hotel-receipt .hotel-info {\n  margin-bottom: 1rem;\n}\n\n.hotel-receipt .info-row {\n  display: flex;\n  align-items: center;\n  font-size: 0.9rem;\n  color: var(--text-primary, #111827);\n  margin-bottom: 0.5rem;\n}\n\n.hotel-receipt .amenities-section {\n  margin-top: 1rem;\n}\n\n.hotel-receipt .amenities-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.hotel-receipt .amenity-tag {\n  background: #f0f9ff;\n  color: #0369a1;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.hotel-receipt .stay-details-section {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-radius: 8px;\n}\n\n.hotel-receipt .subsection-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n  margin: 0 0 0.75rem 0;\n}\n\n.hotel-receipt .stay-info .date-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n}\n\n.hotel-receipt .date-item {\n  text-align: center;\n  flex: 1;\n}\n\n.hotel-receipt .date-label {\n  font-size: 0.8rem;\n  color: var(--text-secondary, #6b7280);\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.hotel-receipt .date-value {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n\n.hotel-receipt .date-separator {\n  margin: 0 1rem;\n  color: var(--text-secondary, #6b7280);\n}\n\n.hotel-receipt .nights-info {\n  text-align: center;\n  font-size: 0.85rem;\n  color: var(--text-secondary, #6b7280);\n  font-weight: 500;\n}\n\n.hotel-receipt .guest-section {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-radius: 8px;\n}\n\n.hotel-receipt .guest-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n\n.hotel-receipt .receipt-payment {\n  padding: 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-radius: 8px;\n  margin-bottom: 1rem;\n}\n\n.hotel-receipt .payment-row.total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n  margin-bottom: 0.5rem;\n}\n\n.hotel-receipt .payment-row.total .total-amount {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--dbs-red, #e31837);\n}\n\n.hotel-receipt .payment-card-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.8rem;\n}\n\n.hotel-receipt .payment-card-row .card-info {\n  color: var(--text-secondary, #6b7280);\n}\n\n.hotel-receipt .payment-card-row .card-benefit {\n  background: #dbeafe;\n  color: #1d4ed8;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 0.7rem;\n}\n\n.hotel-receipt .receipt-footer {\n  padding: 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-top: 1px solid var(--border-color, #e5e7eb);\n  text-align: center;\n}\n\n.hotel-receipt .footer-note {\n  font-size: 0.8rem;\n  color: var(--text-secondary, #6b7280);\n  margin: 0 0 0.5rem 0;\n}\n\n.hotel-receipt .status-badge {\n  display: inline-block;\n}\n\n.hotel-receipt .status {\n  background: #dcfce7;\n  color: #166534;\n  padding: 0.25rem 0.75rem;\n  border-radius: 16px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.hotel-receipt .status.confirmed {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.hotel-receipt .status.pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.hotel-receipt .status.cancelled {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* Room Type Selector Styles */\n.room-type-selector .room-selector-header {\n  padding: 1.5rem 1rem 1rem 1rem;\n  text-align: center;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.room-type-selector .selector-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--text-primary, #111827);\n  margin: 0 0 0.25rem 0;\n}\n\n.room-type-selector .selector-subtitle {\n  font-size: 0.9rem;\n  color: var(--text-secondary, #6b7280);\n  margin: 0 0 0.75rem 0;\n}\n\n.room-type-selector .stay-summary {\n  margin-top: 0.5rem;\n}\n\n.room-type-selector .stay-dates {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #6b7280);\n  font-weight: 500;\n}\n\n.room-type-selector .room-options {\n  padding: 1rem;\n}\n\n.room-type-selector .room-option {\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.room-type-selector .room-option:hover {\n  border-color: #e31837 !important;\n  box-shadow: 0 2px 8px rgba(227, 24, 55, 0.1);\n}\n\n.room-type-selector .room-option.selected {\n  box-shadow: 0 2px 12px rgba(227, 24, 55, 0.15);\n}\n\n.room-type-selector .room-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.room-type-selector .room-info {\n  flex: 1;\n  margin-right: 1rem;\n}\n\n.room-type-selector .room-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n  margin: 0 0 0.25rem 0;\n}\n\n.room-type-selector .room-details {\n  display: flex;\n  align-items: center;\n  font-size: 0.8rem;\n  color: var(--text-secondary, #6b7280);\n}\n\n.room-type-selector .separator {\n  margin: 0 0.5rem;\n}\n\n.room-type-selector .room-price {\n  text-align: right;\n  min-width: 100px;\n}\n\n.room-type-selector .price-per-night {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n  margin-bottom: 0.25rem;\n}\n\n.room-type-selector .per-night {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: var(--text-secondary, #6b7280);\n}\n\n.room-type-selector .total-price {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--dbs-red, #e31837);\n}\n\n.room-type-selector .room-features {\n  margin-top: 0.75rem;\n}\n\n.room-type-selector .features-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.room-type-selector .feature-tag {\n  background: #f0f9ff;\n  color: #0369a1;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.room-type-selector .selection-indicator {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n}\n\n.room-type-selector .radio-circle {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #d1d5db;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.room-type-selector .radio-circle.selected {\n  background: #e31837;\n  border-color: #e31837;\n}\n\n.room-type-selector .room-selector-footer {\n  padding: 1rem;\n  background: var(--bg-light, #f8f9fa);\n  border-top: 1px solid var(--border-color, #e5e7eb);\n  text-align: center;\n}\n\n.room-type-selector .footer-note {\n  font-size: 0.8rem;\n  color: var(--text-secondary, #6b7280);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Compact Footer */\n.flight-receipt .receipt-footer {\n  padding: 0.625rem 1rem;\n  background: var(--bg-white, #fff);\n  text-align: center;\n  border-top: 1px solid var(--border-color, #e5e7eb);\n}\n\n.flight-receipt .footer-note {\n  margin: 0;\n  font-size: 0.7rem;\n  color: var(--text-muted, #9ca3af);\n}\n\n/* Responsive - Compact Receipt */\n@media (max-width: 480px) {\n  .flight-receipt {\n    width: 95%;\n    max-height: 55vh;\n    margin: 0.5rem auto;\n  }\n\n  .flight-receipt .receipt-header {\n    padding: 0.75rem;\n  }\n\n  .flight-receipt .success-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 1rem;\n  }\n\n  .flight-receipt .receipt-title {\n    font-size: 1rem;\n  }\n\n  .flight-receipt .receipt-subtitle {\n    font-size: 0.7rem;\n  }\n\n  .flight-receipt .receipt-reference {\n    padding: 0.5rem 0.75rem;\n  }\n\n  .flight-receipt .route-point .time {\n    font-size: 1rem;\n  }\n}\n\n/* ================================================\n   FLIGHT DATE SELECTOR STYLES\n   ================================================ */\n\n.flight-date-selector {\n  background: white;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.flight-date-selector .date-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.flight-date-selector .nav-arrow {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #ddd;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flight-date-selector .nav-arrow:hover:not(.disabled) {\n  background: #f5f5f5;\n  border-color: #E31837;\n  color: #E31837;\n}\n\n.flight-date-selector .nav-arrow.disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.flight-date-selector .current-date {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.flight-date-selector .current-date:hover {\n  background: #f5f5f5;\n}\n\n.flight-date-selector .date-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.flight-date-selector .calendar-icon {\n  font-size: 20px;\n}\n\n.flight-date-selector .route-info {\n  text-align: center;\n  color: #666;\n  margin-top: 8px;\n  font-size: 14px;\n}\n\n/* Date Picker Modal */\n.date-picker-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.date-picker-modal {\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  width: 320px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.date-picker-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.date-picker-header .month-nav {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #ddd;\n  background: white;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.date-picker-header .month-year {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.date-picker-weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.date-picker-weekdays .weekday {\n  text-align: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  padding: 8px 0;\n}\n\n.date-picker-days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n}\n\n.date-picker-days .day-cell {\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.date-picker-days .day-cell:not(.empty):not(.disabled):hover {\n  background: #f0f0f0;\n}\n\n.date-picker-days .day-cell.selected {\n  background: #E31837;\n  color: white;\n}\n\n.date-picker-days .day-cell.disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n.date-picker-footer {\n  margin-top: 16px;\n  text-align: right;\n}\n\n.date-picker-footer .cancel-btn {\n  padding: 8px 16px;\n  border: none;\n  background: #f5f5f5;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* More Flights Button */\n.more-flights-container {\n  margin-top: 12px;\n  text-align: center;\n}\n\n.more-flights-btn {\n  padding: 12px 24px;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: 100%;\n}\n\n.more-flights-btn:hover {\n  background: #f5f5f5;\n  border-color: #E31837;\n  color: #E31837;\n}\n\n.more-flights-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ================================================\n   PAYMENT CARD INLINE STYLES\n   ================================================ */\n\n.payment-card-inline {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n}\n\n.payment-card-inline .payment-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.payment-card-inline .secure-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.payment-card-inline .secure-icon {\n  font-size: 14px;\n}\n\n.payment-card-inline .secure-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #10B981;\n}\n\n.payment-card-inline .countdown-timer {\n  font-size: 13px;\n  color: #666;\n}\n\n.payment-card-inline .payment-price-section {\n  text-align: center;\n  padding: 20px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.payment-card-inline .total-price {\n  font-size: 28px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.payment-card-inline .payment-booking-summary {\n  margin-top: 12px;\n}\n\n.payment-card-inline .booking-route {\n  font-size: 14px;\n  color: #666;\n  margin: 4px 0;\n}\n\n.payment-card-inline .route-date {\n  color: #999;\n}\n\n.payment-card-inline .payment-cards-section {\n  padding: 20px 0;\n}\n\n.payment-card-inline .cards-loading {\n  text-align: center;\n  color: #666;\n  padding: 20px;\n}\n\n.payment-card-inline .card-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.payment-card-inline .card-option:hover {\n  border-color: #E31837;\n}\n\n.payment-card-inline .card-option.selected {\n  border-color: #E31837;\n  background: #FEF2F2;\n}\n\n.payment-card-inline .card-option input[type=\"radio\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #E31837;\n}\n\n.payment-card-inline .card-icon {\n  font-size: 24px;\n}\n\n.payment-card-inline .card-name {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.payment-card-inline .card-benefit {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 12px;\n}\n\n.payment-card-inline .card-benefit.cashback {\n  background: #ECFDF5;\n  color: #059669;\n}\n\n.payment-card-inline .add-icon {\n  width: 24px;\n  height: 24px;\n  border: 2px dashed #ccc;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: #666;\n}\n\n.payment-card-inline .apple-icon {\n  font-size: 24px;\n}\n\n.payment-card-inline .payment-actions {\n  margin-top: 20px;\n}\n\n.payment-card-inline .pay-now-btn {\n  width: 100%;\n  padding: 16px;\n  background: #E31837;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.payment-card-inline .pay-now-btn:hover:not(:disabled) {\n  background: #C41230;\n}\n\n.payment-card-inline .pay-now-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.payment-card-inline .payment-expired {\n  text-align: center;\n  color: #DC2626;\n  padding: 12px;\n  background: #FEF2F2;\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n/* ================================================\n   PASSENGER CONFIRMATION STYLES\n   ================================================ */\n\n.passenger-confirmation {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.passenger-confirmation .confirmation-header {\n  background: #FEF3C7;\n  padding: 16px;\n  color: #92400E;\n  font-size: 14px;\n}\n\n.passenger-confirmation .flight-summary-card {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.passenger-confirmation .lock-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #10B981;\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n.passenger-confirmation .lock-icon {\n  width: 20px;\n  height: 20px;\n  background: #10B981;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.passenger-confirmation .route-info {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.passenger-confirmation .dates-info {\n  font-size: 13px;\n  color: #666;\n}\n\n.passenger-confirmation .section {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.passenger-confirmation .section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.passenger-confirmation .info-icon {\n  font-size: 14px;\n  cursor: help;\n}\n\n.passenger-confirmation .passenger-card,\n.passenger-confirmation .contact-card {\n  background: #F9FAFB;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.passenger-confirmation .passenger-header,\n.passenger-confirmation .contact-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.passenger-confirmation .passenger-name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.passenger-confirmation .name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.passenger-confirmation .membership-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  background: #DBEAFE;\n  color: #1D4ED8;\n  border-radius: 4px;\n}\n\n.passenger-confirmation .edit-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 50%;\n  transition: background 0.2s;\n}\n\n.passenger-confirmation .edit-btn:hover {\n  background: #E5E7EB;\n}\n\n.passenger-confirmation .passenger-details,\n.passenger-confirmation .contact-details {\n  font-size: 13px;\n  color: #666;\n}\n\n.passenger-confirmation .detail-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 4px 0;\n}\n\n.passenger-confirmation .checkbox {\n  width: 18px;\n  height: 18px;\n  background: #10B981;\n  color: white;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.passenger-confirmation .ff-text {\n  color: #E31837;\n  font-size: 13px;\n}\n\n.passenger-confirmation .add-more-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px;\n  border: none;\n  background: transparent;\n  color: #E31837;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.passenger-confirmation .add-more-btn:hover {\n  background: #FEF2F2;\n  border-radius: 8px;\n}\n\n.passenger-confirmation .plus-icon {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #E31837;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.passenger-confirmation .contact-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.passenger-confirmation .detail-text {\n  font-size: 13px;\n  color: #666;\n  margin: 2px 0;\n}\n\n.passenger-confirmation .baggage-tip {\n  font-size: 13px;\n  color: #059669;\n  margin-bottom: 12px;\n}\n\n.passenger-confirmation .baggage-card {\n  background: #F9FAFB;\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.passenger-confirmation .baggage-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.passenger-confirmation .baggage-icon {\n  font-size: 24px;\n}\n\n.passenger-confirmation .baggage-details {\n  flex: 1;\n}\n\n.passenger-confirmation .baggage-type {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.passenger-confirmation .baggage-info {\n  font-size: 13px;\n  color: #666;\n}\n\n.passenger-confirmation .add-baggage-btn {\n  padding: 8px 16px;\n  background: #10B981;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.passenger-confirmation .krisflyer-section {\n  background: #FEF9E7;\n}\n\n.passenger-confirmation .krisflyer-benefits {\n  padding: 0;\n}\n\n.passenger-confirmation .krisflyer-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.passenger-confirmation .krisflyer-icon {\n  font-size: 20px;\n}\n\n.passenger-confirmation .krisflyer-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #92400E;\n}\n\n.passenger-confirmation .benefits-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.passenger-confirmation .benefit-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #333;\n  margin: 6px 0;\n}\n\n.passenger-confirmation .check-icon {\n  color: #10B981;\n}\n\n.passenger-confirmation .price-section {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.passenger-confirmation .price-label {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.passenger-confirmation .total-price {\n  font-size: 24px;\n  font-weight: 700;\n  color: #E31837;\n}\n\n.passenger-confirmation .confirmation-actions {\n  padding: 20px;\n}\n\n.passenger-confirmation .continue-btn {\n  width: 100%;\n  padding: 16px;\n  background: #E31837;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.passenger-confirmation .continue-btn:hover {\n  background: #C41230;\n}\n\n/* KrisFlyer Badge on FlightCard */\n.flight-card .krisflyer-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  background: linear-gradient(135deg, #FEF3C7, #FDE68A);\n  color: #92400E;\n  border-radius: 12px;\n  margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
